/* Product page 2026 (Steven Design). Kokoon-style motion, Nolan picker.
   1. Accordions: details.pk-acc open/close with a 400ms height animation, cubic-bezier(0.4, 0, 0.2, 1).
      Accordions sharing data-pk-group stay one-open-at-a-time; a split section's image follows.
   2. <pk-gallery>: cross-fading slides, thumbnails, arrows, drag/swipe that fades between neighbours.
   3. <pk-picker>: fabric tabs, colour grid and Seat / Back / Chaise rows with size and quantity inline.
      One request adds every piece; the cart drawer section opens itself on /cart/add.
   4. Size guide drawer, sticky add-to-cart bar, ships-by date. */
(function () {
  if (window.__pdpK) return;
  window.__pdpK = true;

  /* Round 158: prices in the shopper's currency. The section writes {{ 123456789 | money }} (Shopify's format for
     that currency, e.g. "$1,234,567.89", "£1,234,567.89" or "€1.234.567,89"); the symbol, separators and
     decimals come from it. Whole amounts show without decimals (Round 98). */
  function pkMoneyFormat(sample) {
    sample = String(sample || '').replace(/<[^>]*>/g, '');
    var m = /1(\D?)234(\D?)56(?:7(\D)89|8)(?!\d)/.exec(sample);
    if (!m) return null;
    return { pre: sample.slice(0, m.index), post: sample.slice(m.index + m[0].length), thou: m[1], dec: m[3] || '', cents: !!m[3] };
  }
  function pkMoneyOut(c, f, keepDec) {
    var n = Math.round(c), neg = n < 0;
    n = Math.abs(n);
    var parts = (n / 100).toFixed(f.cents && (keepDec || n % 100 !== 0) ? 2 : 0).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return (neg ? '-' : '') + f.pre + parts.join(f.dec) + f.post;
  }

  var ACC_MS = 400;
  var ACC_EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Accordions ---------- */
  function animatePanel(details, open) {
    var panel = details.querySelector(':scope > .pk-acc__content');
    if (!panel || reduceMotion.matches) { details.open = open; return; }
    clearTimeout(details._pkTimer);
    details.classList.toggle('is-closing', !open);
    if (open) details.open = true;
    var full = panel.scrollHeight;
    var from = open ? 0 : panel.getBoundingClientRect().height;
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = from + 'px';
    if (open) panel.style.paddingBottom = '0px';
    panel.offsetHeight; // start the transition from `from`
    panel.style.transition = 'height ' + ACC_MS + 'ms ' + ACC_EASE + ', padding ' + ACC_MS + 'ms ' + ACC_EASE;
    panel.style.height = open ? full + 'px' : '0px';
    panel.style.paddingBottom = open ? '' : '0px';
    details._pkTimer = setTimeout(function () {
      if (!open) details.open = false;
      details.classList.remove('is-closing');
      panel.style.cssText = '';
    }, ACC_MS);
  }

  /* Capture phase: the theme's own accordion script also listens for summary clicks. */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('details.pk-acc > summary');
    if (!summary) return;
    var details = summary.parentElement;
    e.preventDefault();
    e.stopPropagation();
    var opening = !details.open || details.classList.contains('is-closing');
    var group = details.getAttribute('data-pk-group');
    if (opening && group) {
      document.querySelectorAll('details.pk-acc[data-pk-group="' + group + '"]').forEach(function (other) {
        if (other !== details && other.open) animatePanel(other, false);
      });
    }
    animatePanel(details, opening);
    var media = details.getAttribute('data-pk-media');
    if (opening && media && group) {
      document.querySelectorAll('[data-pk-media-box="' + group + '"]').forEach(function (box) {
        var has = box.querySelector('[data-pk-media-item="' + media + '"]');
        if (!has) return;
        box.querySelectorAll('[data-pk-media-item]').forEach(function (m) {
          m.classList.toggle('is-active', m === has);
          var v = m.querySelector('video');
          if (!v) return;
          if (m === has && !reduceMotion.matches) { v.currentTime = 0; playQuietly(v); } else { v.pause(); }
        });
      });
    }
  }, true);

  /* ---------- Gallery ---------- */
  class PkGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.area = this.querySelector('[data-pk-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-pk-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-pk-thumb]'));
      this.index = 0;
      /* Round 140: live site order. Designed slides (not plain photos) stay after a colour's photo list. */
      this._liveKey = this.getAttribute('data-pk-live-key') || '';
      this._tail = this.slides.filter(function (s) { return !s.hasAttribute('data-pk-plain'); });
      var self = this;
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-pk-prev]')) return self.step(-1);
        if (e.target.closest('[data-pk-next]')) return self.step(1);
        var t = e.target.closest('[data-pk-thumb]');
        if (t) self.show(Number(t.getAttribute('data-pk-thumb')));
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.step(-1);
        if (e.key === 'ArrowRight') self.step(1);
      });
      this.bindSwipe();
      this.bindRail();
      /* 1 Nov 2026 gallery test: config for the "real" group (snippets/pdp-k-gallery.liquid). */
      this._gv = pkGvParse(this.querySelector('script[data-pk-gv]'));
      this._gvColour = this._gv ? this._gv.colour : '';
      this.gvAfterBuild();
      this.buildMinis();
      var self2 = this;
      window.addEventListener('resize', function () { self2.scaleMinis(); });
      this.show(0);
    }
    step(dir) {
      var len = this.slides.length;
      var next = (this.index + dir + len) % len;
      if (next !== this.index) this.show(next, dir);
    }
    /* Ruggable-style slide: every slide sits at --pk-off widths from the active one and slides there in .3s.
       The strip loops, so a slide that wraps round from one side to the other jumps while off screen. */
    place(dir) {
      var len = this.slides.length, self = this;
      var target = this.slides[this.index];
      if (dir && target && target._pkOff !== undefined && target._pkOff * dir <= 0 && target._pkOff !== 0) this.jump(target, dir);
      this.slides.forEach(function (s, idx) {
        var d = idx - self.index;
        if (len > 2) { if (d > len / 2) d -= len; if (d < -len / 2) d += len; }
        else if (len === 2 && d !== 0) d = -(dir || -1);
        var prev = s._pkOff;
        if (prev !== undefined && prev !== 0 && d !== 0 && prev * d < 0) self.jump(s, d);
        else s.style.setProperty('--pk-off', d);
        s._pkOff = d;
      });
    }
    jump(s, off) {
      s.style.transition = 'none';
      s.style.setProperty('--pk-off', off);
      s._pkOff = off;
      s.offsetWidth;
      s.style.transition = '';
    }
    show(i, dir) {
      if (!this.slides.length) return;
      var from = this.index;
      this.index = Math.min(this.slides.length - 1, Math.max(0, i));
      if (dir === undefined && from !== undefined && from !== this.index) {
        var len = this.slides.length, d = this.index - from;
        if (len > 2) { if (d > len / 2) d -= len; if (d < -len / 2) d += len; }
        dir = d < 0 ? -1 : 1;
      }
      this.place(dir);
      var self = this;
      this.slides.forEach(function (s, idx) {
        var on = idx === self.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      this.thumbs.forEach(function (t, idx) { t.setAttribute('aria-current', String(idx === self.index)); });
      var prev = this.querySelector('[data-pk-prev]');
      var next = this.querySelector('[data-pk-next]');
      if (prev) prev.disabled = this.slides.length < 2;
      if (next) next.disabled = this.slides.length < 2;
      var count = this.querySelector('[data-pk-count]');
      if (count) count.textContent = (this.index + 1) + ' / ' + this.slides.length;
      this.style.setProperty('--pk-n', this.slides.length);
      this.style.setProperty('--pk-i', this.index);
      var cur = this.slides[this.index];
      this.classList.toggle('is-bar', !!(cur && cur.querySelector('.pk-s__bar')));
      this.classList.toggle('is-chips', !!(cur && cur.querySelector('.pk-s__chips')));
      this.classList.toggle('is-designed', !!(cur && !cur.hasAttribute('data-pk-plain')));
      this.centerThumb(this.thumbs[this.index]);
    }
    centerThumb(thumb) {
      var row = this.querySelector('[data-pk-thumbs]');
      if (!row || !thumb) return;
      if (!row.clientHeight) return;
      var rr = row.getBoundingClientRect();
      var tr = thumb.getBoundingClientRect();
      if (getComputedStyle(row).flexDirection === 'column') {
        row.scrollTo({ top: Math.max(0, row.scrollTop + tr.top - rr.top - (row.clientHeight - tr.height) / 2), behavior: 'smooth' });
      } else {
        row.scrollTo({ left: Math.max(0, row.scrollLeft + tr.left - rr.left - (row.clientWidth - tr.width) / 2), behavior: 'smooth' });
      }
    }
    useLive(list, name) {
      var area = this.area, row = this.querySelector('[data-pk-thumbs]');
      if (!area) return;
      var anchor = area.querySelector('[data-pk-prev]');
      this.slides.forEach(function (s) { s.remove(); });
      var html = '', th = '';
      list.forEach(function (m, i) {
        html += '<div class="pk-gal__slide" data-pk-slide data-pk-plain data-pk-live aria-hidden="true"><div class="pk-s"><img class="pk-s__photo" src="' + esc(m.src) + '" alt="' + esc(m.alt || name) + '" width="1400" height="1400"' + (i ? ' loading="lazy"' : '') + '></div></div>';
        th += '<button type="button" class="pk-gal__thumb" data-pk-thumb="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + esc(m.thumb) + '" alt="" width="160" height="160" loading="lazy"></button>';
      });
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var slides = Array.prototype.slice.call(tpl.content.children).concat(this._tail || []);
      var self = this;
      (this._tail || []).forEach(function (s, j) {
        var n = list.length + j;
        th += '<button type="button" class="pk-gal__thumb" data-pk-thumb="' + n + '" aria-label="Image ' + (n + 1) + '"></button>';
      });
      slides.forEach(function (s) { area.insertBefore(s, anchor); });
      this.slides = slides;
      if (row) {
        row.innerHTML = th;
        row.scrollTop = 0;
        row.scrollLeft = 0;
        row.dispatchEvent(new Event('scroll'));
        row.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', function () { row.dispatchEvent(new Event('scroll')); }); });
      }
      this.thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pk-thumb]')) : [];
      this.gvAfterBuild();
      this.buildMinis();
      this.show(0);
    }
    /* Called by the picker when the fabric changes (live kv-sofa-cover-bundle behaviour: the gallery
       shows the picked product's own media). home=true restores the designed slides of this page. */
    useFabric(fabric, home, plain) {
      var area = this.area;
      var row = this.querySelector('[data-pk-thumbs]');
      if (!area) return;
      if (!this._home) this._home = this._gvBase ? { slides: this._gvBase.slice(), thumbs: this._gvBaseThumbs } : { slides: this.slides.slice(), thumbs: row ? row.innerHTML : '' };
      /* Round 164: a fabric picked in place shows the same slides as a fresh load of its page (section rendering),
         not every photo of the product. plain=true is the old behaviour, used when that request fails. */
      if (!home && !plain && fabric && fabric.handle && this.sectionId()) { this.loadFabric(fabric); return; }
      this._want = null;
      var anchor = area.querySelector('[data-pk-prev]');
      this.slides.forEach(function (s) { s.remove(); });
      var slides;
      if (home || !fabric || !fabric.media || !fabric.media.length) {
        slides = this._home.slides;
        if (row) row.innerHTML = this._home.thumbs;
      } else {
        var name = esc(fabric.title);
        var html = '<div class="pk-gal__slide" data-pk-slide data-pk-colour-slide data-pk-plain aria-hidden="true"><div class="pk-s pk-s--colour"><img class="pk-s__photo" data-pk-colour-photo src="' + esc(fabric.media[0].src) + '"' + (srcsetOf(fabric.media[0].src) ? ' srcset="' + esc(srcsetOf(fabric.media[0].src)) + '" sizes="(min-width: 990px) 52vw, 100vw"' : '') + ' alt="' + name + '" width="1400" height="1400"><span class="pk-s__tag">Shown in <span data-pk-colour-name></span></span></div></div>';
        var th = '<button type="button" class="pk-gal__thumb" data-pk-thumb="0" aria-label="Selected colour photo"><img data-pk-colour-thumb src="' + esc(fabric.media[0].thumb) + '" alt="" width="160" height="160"></button>';
        /* Round 163: the fabric's colour close-up goes second; setColour fills in the picked colour. */
        var off = 1, cu0 = (fabric.colours || []).find(function (c) { return c.closeup; });
        if (cu0) {
          html += '<div class="pk-gal__slide" data-pk-slide data-pk-closeup-slide data-pk-plain aria-hidden="true"><div class="pk-s"><img class="pk-s__photo" data-pk-closeup-photo src="' + esc(cu0.closeup) + '" alt="' + esc(cu0.name) + ' fabric close-up" width="1400" height="1400" loading="lazy"></div></div>';
          th += '<button type="button" class="pk-gal__thumb" data-pk-thumb="1" aria-label="Close-up of the selected colour"><img data-pk-closeup-thumb src="' + esc(cu0.closeupThumb) + '" alt="" width="160" height="160" loading="lazy"></button>';
          off = 2;
        }
        fabric.media.forEach(function (m, i) {
          html += '<div class="pk-gal__slide" data-pk-slide data-pk-plain aria-hidden="true"><div class="pk-s"><img class="pk-s__photo" src="' + esc(m.src) + '" alt="' + esc(m.alt) + '" width="1400" height="1400" loading="lazy"></div></div>';
          th += '<button type="button" class="pk-gal__thumb" data-pk-thumb="' + (i + off) + '" aria-label="Image ' + (i + off + 1) + '"><img src="' + esc(m.thumb) + '" alt="" width="160" height="160" loading="lazy"></button>';
        });
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        slides = Array.prototype.slice.call(tpl.content.children);
        if (row) row.innerHTML = th;
      }
      this._minisDirty = true;
      slides.forEach(function (s) { area.insertBefore(s, anchor); });
      this.slides = slides;
      this.thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pk-thumb]')) : [];
      if (row) {
        row.scrollTop = 0;
        row.scrollLeft = 0;
        row.dispatchEvent(new Event('scroll'));
        row.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', function () { row.dispatchEvent(new Event('scroll')); }); });
      }
      /* Back on this page's own fabric: its own test config; another fabric's photos: none. */
      this._gv = home ? pkGvParse(this.querySelector('script[data-pk-gv]')) : null;
      this.gvAfterBuild();
      this.buildMinis();
      this.show(0);
    }
    /* Called by the picker. Swaps the selected-colour slide's photo, and the colour grid slide. */
    sectionId() {
      var sec = this.closest('[id^="shopify-section-"]');
      return sec ? sec.id.replace('shopify-section-', '') : '';
    }
    loadFabric(fabric) {
      var self = this, key = fabric.handle;
      this._want = key;
      this._gcache = this._gcache || {};
      if (!this._gcache[key]) {
        var url = '/products/' + encodeURIComponent(key) + '?section_id=' + encodeURIComponent(this.sectionId());
        this._gcache[key] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var g = new DOMParser().parseFromString(html, 'text/html').querySelector('pk-gallery');
            if (!g || !g.querySelector('[data-pk-slide]')) throw new Error('no gallery in the response');
            var row = g.querySelector('[data-pk-thumbs]');
            return {
              slides: Array.prototype.slice.call(g.querySelectorAll('[data-pk-slide]')).map(function (sl) { return sl.outerHTML; }).join(''),
              thumbs: row ? row.innerHTML : '',
              liveKey: g.getAttribute('data-pk-live-key') || '',
              gv: g.querySelector('script[data-pk-gv]')
            };
          });
        this._gcache[key].catch(function () { delete self._gcache[key]; });
      }
      this._gcache[key].then(function (res) {
        if (self._want !== key) return;
        self.swapSlides(res);
        if (self._lastColour) self.setColour(self._lastColour, self._lastFabric, false);
      }).catch(function (err) {
        console.error('[pdp-k] could not load the gallery for ' + key + '; showing its photos instead', err);
        if (self._want === key) self.useFabric(fabric, false, true);
      });
    }
    swapSlides(res) {
      var area = this.area, row = this.querySelector('[data-pk-thumbs]');
      if (!area) return;
      var anchor = area.querySelector('[data-pk-prev]');
      this.slides.forEach(function (sl) { sl.remove(); });
      var tpl = document.createElement('template');
      tpl.innerHTML = res.slides;
      var slides = Array.prototype.slice.call(tpl.content.children);
      slides.forEach(function (sl, i) {
        sl.classList.toggle('is-active', i === 0);
        sl.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        area.insertBefore(sl, anchor);
      });
      this.slides = slides;
      if (this.hasAttribute('data-pk-live-key')) {
        this._liveKey = res.liveKey;
        this._tail = slides.filter(function (sl) { return !sl.hasAttribute('data-pk-plain'); });
      }
      if (row) {
        row.innerHTML = res.thumbs;
        row.scrollTop = 0;
        row.scrollLeft = 0;
        row.dispatchEvent(new Event('scroll'));
        row.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', function () { row.dispatchEvent(new Event('scroll')); }); });
      }
      this.thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pk-thumb]')) : [];
      this._minisDirty = true;
      this._gv = pkGvParse(res.gv);
      this.gvAfterBuild();
      this.buildMinis();
      this.show(0);
    }
    setColour(colour, fabric, jump) {
      /* Round 164: kept so the colour can be applied again after a fabric's slides load. */
      this._lastColour = colour;
      this._lastFabric = fabric;
      /* 1 Nov 2026 gallery test: photo slides with a colour map follow the picked colour. */
      if (colour && colour.name && colour.name !== this._gvColour) { this._gvColour = colour.name; this.gvRecolour(); }
      /* Round 140: a colour with its own photo list (live site order) shows that list. */
      if (colour && colour.live && colour.live.length && this.hasAttribute('data-pk-live-key')) {
        var lkey = (fabric && fabric.handle ? fabric.handle : '') + '|' + colour.name;
        if (this._liveKey !== lkey) { this._liveKey = lkey; this.useLive(colour.live.concat(fabric && fabric.shared ? fabric.shared : []), colour.name); }
        else if (jump) this.show(0);
        return;
      }
      /* Round 96: photo slides with the same shot in the picked colour (data-pk-csrc) follow the colour. */
      if (colour) {
        this.querySelectorAll('[data-pk-csrc]').forEach(function (el) {
          var map;
          try { map = JSON.parse(el.getAttribute('data-pk-csrc')); } catch (e) { return; }
          /* Round 167: a slide with data-pk-cshift shows the colour that many places after the picked one. */
          var cname = colour.name, sh = parseInt(el.getAttribute('data-pk-cshift'), 10);
          if (sh) {
            var order = (el.getAttribute('data-pk-corder') || '').split('|'), ci = order.indexOf(colour.name);
            if (ci !== -1) cname = order[(ci + sh) % order.length];
          }
          var url = map[cname], im = el.querySelector('img');
          if (!url || !im || im.getAttribute('src') === url) return;
          im.removeAttribute('srcset');
          im.removeAttribute('sizes');
          im.src = url;
        });
      }
      var slide = this.querySelector('[data-pk-colour-slide]');
      if (slide && colour) {
        var img = slide.querySelector('[data-pk-colour-photo]');
        if (colour.photo && img.getAttribute('src') !== colour.photo) {
          /* QA 17 Oct (speed H32): keep the srcset in step, so phones still load a smaller file. */
          var ss = srcsetOf(colour.photo);
          if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
          img.src = colour.photo;
        }
        img.alt = colour.name;
        slide.querySelectorAll('[data-pk-colour-name]').forEach(function (el) { el.textContent = colour.name; });
        var th = this.querySelector('[data-pk-colour-thumb]');
        if (th && colour.thumb) th.src = colour.thumb;
      }
      /* Round 163: the selected colour's fabric close-up (data-pk-closeup-slide). */
      var cu = this.querySelector('[data-pk-closeup-slide]');
      if (cu && colour && colour.closeup) {
        var cim = cu.querySelector('[data-pk-closeup-photo]');
        if (cim && cim.getAttribute('src') !== colour.closeup) {
          var css = srcsetOf(colour.closeup);
          if (css) cim.setAttribute('srcset', css); else cim.removeAttribute('srcset');
          cim.src = colour.closeup;
        }
        if (cim) cim.alt = colour.name + ' fabric close-up';
        var cth = this.querySelector('[data-pk-closeup-thumb]');
        if (cth && colour.closeupThumb) cth.src = colour.closeupThumb;
      }
      if (fabric) {
        var grid = this.querySelector('[data-pk-swatch-grid]');
        if (grid && grid.getAttribute('data-fabric') !== fabric.handle) {
          grid.setAttribute('data-fabric', fabric.handle);
          grid.innerHTML = fabric.colours.map(function (c) {
            return '<div class="pk-s__sw"><span' + (c.hex ? ' style="background:' + esc(c.hex) + '"' : '') + '>' + (!c.hex && c.swatch ? '<img src="' + c.swatch + '" alt="" loading="lazy">' : '') + '</span><em>' + esc(c.name) + '</em></div>';
          }).join('');
          this.querySelectorAll('[data-pk-colour-count]').forEach(function (el) { el.textContent = fabric.colours.length; });
        }
      }
      this.buildMinis();
      if (jump && slide) this.show(this.slides.indexOf(slide));
    }
    /* ---------- 1 Nov 2026 gallery test ("real sofas, fit first") ----------
       gvAfterBuild runs after every slide rebuild (first load, colour list, fabric switch). It keeps the control
       slides and thumbnails, then, for the "real" group only, puts the slides in the test order. */
    gvAfterBuild() {
      var row = this.querySelector('[data-pk-thumbs]');
      this._gvBase = this.slides.filter(function (sl) { return !sl.hasAttribute('data-pk-gv'); });
      this._gvBaseThumbs = row ? row.innerHTML : '';
      if (this._gv && pkGalMode() === 'real') this.gvArrange();
    }
    /* Mode changed (nolan:gal): rebuild from the control slides. */
    gvRefresh() {
      if (!this._gvBase) return;
      var area = this.area, row = this.querySelector('[data-pk-thumbs]');
      if (!area) return;
      if (this._gv && pkGalMode() === 'real') {
        this.gvArrange();
      } else {
        this.gvPlace(this._gvBase);
        if (row) row.innerHTML = this._gvBaseThumbs;
        this.thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pk-thumb]')) : [];
      }
      this.buildMinis();
      this.show(0);
    }
    gvPlace(list) {
      var area = this.area, anchor = area.querySelector('[data-pk-prev]');
      this.slides.forEach(function (sl) { sl.remove(); });
      list.forEach(function (sl, i) {
        sl.classList.toggle('is-active', i === 0);
        sl.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        area.insertBefore(sl, anchor);
      });
      this.slides = list;
    }
    gvArrange() {
      var cfg = this._gv, self = this;
      if (!cfg || !this._gvBase) return;
      var nm = function (t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
      var fileOf = function (sl) {
        var im = sl.querySelector('img');
        return im ? nm((im.getAttribute('src') || '').split('?')[0].split('/').pop()) : '';
      };
      var drops = cfg.drop.map(nm).filter(Boolean);
      var keep = this._gvBase.filter(function (sl) {
        if (!sl.hasAttribute('data-pk-plain')) return true;
        var f = fileOf(sl);
        return !drops.some(function (d) { return f.indexOf(d) !== -1; });
      });
      var used = [], out = [];
      cfg.order.forEach(function (line) {
        if (line.charAt(0) === '@') {
          var el = self.gvSlide(line.slice(1).trim());
          if (el) out.push(el);
          return;
        }
        var frags = line.split(',').map(nm).filter(Boolean);
        for (var i = 0; i < keep.length; i++) {
          var sl = keep[i];
          if (used.indexOf(sl) !== -1 || !sl.hasAttribute('data-pk-plain')) continue;
          var f = fileOf(sl);
          if (frags.some(function (fr) { return f.indexOf(fr) !== -1; })) { used.push(sl); out.push(sl); break; }
        }
      });
      var rest = keep.filter(function (sl) { return used.indexOf(sl) === -1; });
      out = out.concat(rest.filter(function (sl) { return sl.hasAttribute('data-pk-plain'); }), rest.filter(function (sl) { return !sl.hasAttribute('data-pk-plain'); }));
      if (!out.length) return;
      this.gvPlace(out);
      var row = this.querySelector('[data-pk-thumbs]');
      if (row) {
        row.innerHTML = out.map(function (sl, i) { return '<button type="button" class="pk-gal__thumb" data-pk-thumb="' + i + '" aria-label="Image ' + (i + 1) + '"></button>'; }).join('');
        row.scrollTop = 0;
        row.scrollLeft = 0;
        row.dispatchEvent(new Event('scroll'));
      }
      this.thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pk-thumb]')) : [];
    }
    /* A test slide: "compare" (k_gv_vs) or a photo from k_gv_slides, in the picked colour when there is one. */
    gvSlide(key) {
      var cfg = this._gv, tpl = document.createElement('template');
      if (key === 'compare') {
        var lines = String(cfg.vs || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
        if (lines.length < 3) return null;
        var heads = lines[1].split('|');
        var yes = '<i class="pk-s__yes"><svg viewBox="0 0 12 12" aria-hidden="true"><polyline points="2.5,6.5 5,9 9.5,3.5"/></svg></i>';
        var no = '<i class="pk-s__no"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6"/></svg></i>';
        var rows = lines.slice(2).map(function (l) {
          var p = l.split('|');
          if (p.length < 3) return '';
          var us = p[1].trim().toLowerCase() === 'y', them = p[2].trim().toLowerCase() === 'y';
          return '<div class="pk-s__vs-row"><span>' + esc(p[0].trim()) + '</span><span class="pk-s__vs-us">' + (us ? yes : no) + '<span class="pk-sr">' + (us ? 'Yes' : 'No') + '</span></span><span class="pk-s__vs-them">' + (them ? yes : no) + '<span class="pk-sr">' + (them ? 'Yes' : 'No') + '</span></span></div>';
        }).join('');
        tpl.innerHTML = '<div class="pk-gal__slide" data-pk-slide data-pk-gv="compare" aria-hidden="true"><div class="pk-s pk-s--gvvs"><div class="pk-s__head"><p class="pk-s__title">' + esc(lines[0]) + '</p></div><div class="pk-s__vs"><div class="pk-s__vs-row pk-s__vs-row--head"><span></span><span class="pk-s__vs-us">' + esc((heads[0] || 'Nolan').trim()) + '</span><span class="pk-s__vs-them">' + esc((heads[1] || 'Others').trim()) + '</span></div>' + rows + '</div></div></div>';
        return tpl.content.firstElementChild;
      }
      var d = cfg.slides && cfg.slides[key];
      if (!d || !d.map) return null;
      var name = this._gvColour && d.map[this._gvColour] ? this._gvColour : d.fallback;
      var m = d.map[name];
      if (!m || !m.src) return null;
      var ss = srcsetOf(m.src);
      tpl.innerHTML = '<div class="pk-gal__slide" data-pk-slide data-pk-plain data-pk-gv="' + esc(key) + '" aria-hidden="true"><div class="pk-s"><img class="pk-s__photo" src="' + esc(m.src) + '"' + (ss ? ' srcset="' + esc(ss) + '" sizes="(min-width: 990px) 52vw, 100vw"' : '') + ' alt="' + esc(d.alt || '') + '" width="1400" height="1400" loading="lazy"><span class="pk-s__gvtag">Shown in ' + esc(name) + '</span></div></div>';
      return tpl.content.firstElementChild;
    }
    /* Colour picked: swap test photo slides that have a photo in that colour (or go back to their fallback). */
    gvRecolour() {
      if (!this._gv || pkGalMode() !== 'real') return;
      var self = this, changed = false;
      this.slides.slice().forEach(function (sl, i) {
        var key = sl.getAttribute('data-pk-gv');
        if (!key || key === 'compare') return;
        var el = self.gvSlide(key);
        if (!el) return;
        var a = sl.querySelector('img'), b = el.querySelector('img');
        if (a && b && a.getAttribute('src') === b.getAttribute('src')) return;
        el.classList.toggle('is-active', sl.classList.contains('is-active'));
        el.setAttribute('aria-hidden', sl.getAttribute('aria-hidden'));
        if (sl.style.getPropertyValue('--pk-off')) el.style.setProperty('--pk-off', sl.style.getPropertyValue('--pk-off'));
        el._pkOff = sl._pkOff;
        sl.replaceWith(el);
        self.slides[i] = el;
        changed = true;
      });
      if (changed) this.buildMinis();
    }
    /* Thumbnails are small copies of their slides, so a designed slide looks the same in the strip. */
    buildMinis() {
      var self = this;
      this.thumbs.forEach(function (t, i) {
        var slide = self.slides[i];
        var src = slide && slide.querySelector('.pk-s');
        if (!src) return;
        var c = src.cloneNode(true);
        [c].concat(Array.prototype.slice.call(c.querySelectorAll('*'))).forEach(function (el) {
          el.removeAttribute('id');
          Array.prototype.slice.call(el.attributes).forEach(function (a) { if (a.name.indexOf('data-pk') === 0) el.removeAttribute(a.name); });
        });
        c.querySelectorAll('img').forEach(function (im) {
          im.setAttribute('loading', 'eager');
          im.setAttribute('alt', '');
          im.removeAttribute('fetchpriority');
          var s0 = im.getAttribute('src') || '';
          if (/[?&]width=\d+/.test(s0)) im.setAttribute('src', s0.replace(/([?&]width=)\d+/, '$1300'));
          if (im.hasAttribute('srcset')) im.setAttribute('sizes', '200px');
        });
        var wrap = document.createElement('span');
        wrap.className = 'pk-gal__mini';
        wrap.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('span');
        inner.className = 'pk-gal__mini-in';
        inner.appendChild(c);
        wrap.appendChild(inner);
        Array.prototype.slice.call(t.children).forEach(function (ch) { ch.remove(); });
        t.appendChild(wrap);
      });
      this.scaleMinis();
    }
    scaleMinis() {
      var t = this.thumbs[0];
      var m = t && t.querySelector('.pk-gal__mini');
      if (!m || !m.clientWidth) return;
      this.style.setProperty('--pk-ms', (m.clientWidth / 600).toFixed(4));
    }
    /* Thin scroll line beside the thumbnail column (the native scrollbar is hidden). */
    bindRail() {
      var row = this.querySelector('[data-pk-thumbs]');
      var rail = this.querySelector('[data-pk-rail]');
      if (!row || !rail) return;
      var bar = rail.firstElementChild;
      var update = function () {
        var h = row.clientHeight, sh = row.scrollHeight;
        if (!h || sh <= h + 1) { rail.classList.add('is-full'); bar.style.height = '100%'; bar.style.transform = ''; return; }
        rail.classList.remove('is-full');
        var size = h / sh;
        bar.style.height = (size * 100) + '%';
        bar.style.transform = 'translateY(' + (row.scrollTop / (sh - h)) * ((1 - size) / size) * 100 + '%)';
      };
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      row.querySelectorAll('img').forEach(function (im) { im.addEventListener('load', update); });
      update();
    }
    bindSwipe() {
      var area = this.area;
      if (!area) return;
      var self = this;
      var drag = null;
      area.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.target.closest('button, video, iframe, a')) return;
        if (e.pointerType === 'mouse') e.preventDefault();
        drag = { x: e.clientX, y: e.clientY, time: performance.now(), dx: 0, dir: 0, target: -1, active: false };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          drag.active = true;
          area.classList.add('is-dragging');
        }
        var len = self.slides.length;
        if (len < 2) return;
        var dir = dx < 0 ? 1 : -1;
        if (dir !== drag.dir) {
          drag.dir = dir;
          drag.target = (self.index + dir + len) % len;
          self.place(dir);
          self.jump(self.slides[drag.target], dir);
        }
        drag.dx = dx;
        area.style.setProperty('--pk-drag', dx + 'px');
      });
      var end = function (e) {
        if (!drag) return;
        var d = drag;
        drag = null;
        if (!d.active) return;
        var quickFlick = performance.now() - d.time < 300 && Math.abs(d.dx) > 20;
        var advance = e.type === 'pointerup' && d.target >= 0 && (Math.abs(d.dx) > area.clientWidth * 0.25 || quickFlick);
        area.classList.remove('is-dragging');
        area.style.removeProperty('--pk-drag');
        if (advance) self.show(d.target, d.dir);
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }
  }
  if (!customElements.get('pk-gallery')) customElements.define('pk-gallery', PkGallery);

  /* Spend and Save test (Intelligems, from 2 Nov 2026). The test sets localStorage "nolan_offer" to "ss" or "ladder" and
     fires "nolan:offer"; ?nolan_offer=ss|ladder does the same for previews. US dollar carts only. The cart attribute
     _nolan_offer tells the checkout discount which prices apply. */
  function pkOffer() {
    var o = 'ladder';
    try {
      var m = /[?&]nolan_offer=(ss|ladder)(&|$)/.exec(window.location.search);
      if (m) window.localStorage.setItem('nolan_offer', m[1]);
      o = window.localStorage.getItem('nolan_offer') === 'ss' ? 'ss' : 'ladder';
    } catch (err) { console.error('[pdp-k] could not read the offer group', err); }
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    return o === 'ss' && (!cur || cur === 'USD') ? 'ss' : 'ladder';
  }
  function pkOfferSync(cart) {
    var want = pkOffer(), have = (cart && cart.attributes && cart.attributes._nolan_offer) || 'ladder';
    if (have === want) return Promise.resolve(cart);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { _nolan_offer: want } })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  /* 1 Nov 2026 gallery test (Intelligems). The test sets localStorage "nolan_gal" to "real" or "control" and fires
     "nolan:gal"; ?nolan_gal=real|control does the same for previews. Anything else is control. */
  function pkGalMode() {
    try {
      var m = /[?&]nolan_gal=(real|control)(&|$)/.exec(window.location.search);
      if (m) window.localStorage.setItem('nolan_gal', m[1]);
      return window.localStorage.getItem('nolan_gal') === 'real' ? 'real' : 'control';
    } catch (err) { console.error('[pdp-k] could not read the gallery test group', err); return 'control'; }
  }
  function pkGvParse(el) {
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      var lines = function (t) { return String(t || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); };
      c.order = lines(c.order);
      c.drop = lines(c.drop);
      return c.order.length ? c : null;
    } catch (err) { console.error('[pdp-k] gallery test config is not valid JSON', err); return null; }
  }
  document.addEventListener('nolan:gal', function () {
    document.querySelectorAll('pk-gallery').forEach(function (g) { if (g.gvRefresh) g.gvRefresh(); });
  });
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Shopify CDN image URL with a width= parameter -> srcset of the same widths the Liquid slide uses. */
  function srcsetOf(url) {
    if (!/[?&]width=\d+/.test(url)) return '';
    return [450, 600, 900, 1200, 1400].map(function (w) { return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
  }

  /* ---------- Picker ---------- */
  var SIZE_NAMES = { S: 'Small', M: 'Medium', L: 'Large' };
  class PkPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var D = this.D = JSON.parse(this.querySelector('[data-pk-picker-data]').textContent);
      /* Owner, 29 Oct 2026: one colour order for every fabric (k_colour_sort), light to dark within each colour family.
         Colours not in the list keep their own order at the end. */
      if (D.colourSort && D.fabrics) {
        var ord = String(D.colourSort).toLowerCase().split(/\s*[\n,]\s*/).filter(Boolean);
        var rank = function (c) { var r = ord.indexOf(String(c.name).toLowerCase()); return r < 0 ? 999 : r; };
        D.fabrics.forEach(function (f) {
          if (!f.colours) return;
          f.colours = f.colours.map(function (c, i) { return { c: c, i: i }; }).sort(function (a, b) { return rank(a.c) - rank(b.c) || a.i - b.i; }).map(function (o) { return o.c; });
        });
      }
      this.mf = pkMoneyFormat(D.moneySample);
      this.fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD' });
      /* Round 98: whole-dollar amounts show as "$179", not "$179.00" (owner, like the bedding cards). */
      this.fmt0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      this.article = this.closest('.pk');
      this.gallery = this.article && this.article.querySelector('pk-gallery');
      this.fabric = D.fabrics.find(function (f) { return f.current; }) || D.fabrics[0];
      this.single = D.mode === 'single';
      this.duo = this.single && !!D.duo;
      this.state = {
        colour: D.defaultColour,
        size: '', qty: 1,
        pack: this.duo ? (+D.duoStart === 1 ? 1 : 2) : 1, active: 0, items: [],
        seat: { qty: D.seat, size: D.defaultSize },
        back: { qty: D.back, size: D.defaultSize },
        chaise: { qty: D.chaise, size: D.defaultSize === 'S' ? 'M' : D.defaultSize }
      };
      this.adding = false;
      /* 28 Oct 2026: sofa cover piece pricing (D.ladder from snippets/sofa-tier-prices.liquid). Every seat, back and chaise
         cover in the cart counts toward one piece total, and every piece is priced at its size's price for that total.
         _focus is the size picked last; the ladder shows its price per piece at each tier. */
      this.L = !this.single && D.ladder ? D.ladder : null;
      this.L0 = this.L;
      this.SS = null;
      /* Owner, 31 Oct 2026: the ladder starts on Seat Small prices. */
      this._focus = { piece: 'seat', size: 'S' };
      this.cartPieces = 0;
      /* Round 174 (phone QA, 24 Oct 2026): the sizes the template starts on, and the rows where the shopper has picked a size. */
      this._baseSize = { seat: this.state.seat.size, back: this.state.back.size, chaise: this.state.chaise.size };
      this._userSize = {};
      this.index();
      this.openInStock();
      this.pickInStock();
      this.idleSizes();
      if (this.L) this.ladInit();
      if (this.L) { this.ssApply(false); var me = this; document.addEventListener('nolan:offer', function () { me.ssApply(true); }); }
      if (this.duo) {
        this.duoInitItems();
        this.classList.add('pk-pick--duo');
      }
      this.renderFabrics();
      this.renderColours();
      this.bind();
      this.render();
      this.syncGallery(false);
      if (this.L) this.watchCart();
    }
    /* ---- Sofa cover piece pricing (28 Oct 2026) ---- */
    ladLine() { return this.L ? this.L.lines[this.L.products[this.fabric.handle]] || null : null; }
    ladRow(piece, size) {
      var ln = this.ladLine(), r = ln ? ln[piece.charAt(0).toUpperCase() + piece.slice(1) + ' Cover (' + size + ')'] || null : null;
      if (r === null || !this.SS) return r;
      /* Spend and Save test: one flat price at every tier; [4] is the live compare-at price (crossed out). */
      var v = this.variant(piece, size, this.state.colour), ca = v && v.compare > 0 ? v.compare / 100 : r;
      return [r, r, r, r, Math.max(ca, r)];
    }
    /* Spend and Save test: switch between the piece-price ladder and flat prices with spend tiers. */
    ssApply(again) {
      var on = !!(this.L0 && this.g1 && this.D.flat && pkOffer() === 'ss');
      if (again && !!this.SS === on) return;
      this.SS = on ? this.D.flat : null;
      this.L = on ? { breaks: this.L0.breaks, labels: this.L0.labels, products: this.D.flat.products, lines: this.D.flat.lines } : this.L0;
      this.classList.toggle('pk-pick--ss', on);
      var box = this.querySelector('[data-pk-ladder]');
      if (box) box.querySelectorAll('[data-pk-node], .pk-ladder__h, [data-pk-ss-msg]').forEach(function (n) { n.remove(); });
      /* Owner, 30 Oct 2026: the spend tiers sit right above Add To Cart; the ladder stays above Select covers. */
      if (box && !this._ladHome) {
        if (this.g1 && !this._ladMoved) { var grpH = box.closest('.pk-pick__group'); if (grpH) { grpH.parentNode.insertBefore(box, grpH); box.classList.add('pk-ladder--top'); this._ladMoved = true; } }
        this._ladHome = { parent: box.parentNode, next: box.nextElementSibling };
      }
      var atcBtn = this.querySelector('[data-pk-atc]');
      /* Owner, 31 Oct 2026: the piece-price table above Add To Cart too, like the spend tiers. */
      if (box && atcBtn) atcBtn.parentNode.insertBefore(box, atcBtn);
      else if (box && this._ladHome) this._ladHome.parent.insertBefore(box, this._ladHome.next);
      this._ladBuilt = false;
      this._ssK = undefined;
      if (!again) return;
      this.render();
      var keepCart = this;
      if (this._cart) pkOfferSync(this._cart).then(function (c) { if (c) keepCart._cart = c; }).catch(function (err) { console.error('[pdp-k] could not save the offer group on the cart', err); });
    }
    ssRender(box) {
      var self = this, T = this.SS.tiers, top = T.length - 1, track = box.querySelector('[data-pk-ladder-track]');
      var nudge = this.querySelector('[data-pk-nudge]');
      if (nudge) nudge.hidden = true;
      if (this._ladBuilt !== 'ss') {
        this._ladBuilt = 'ss';
        track.insertAdjacentHTML('beforeend', T.map(function (t, i) {
          return '<div class="pk-ladder__node' + (i === top ? ' is-best' : '') + '" data-pk-node="' + i + '"><span class="pk-ladder__lab">$' + t.at + '</span><span class="pk-ladder__dot" aria-hidden="true"></span><span class="pk-ladder__pr">' + esc(t.off ? '$' + t.off + ' off' : 'Free shipping') + '</span></div>';
        }).join(''));
      }
      /* Spend so far: the covers picked here at their flat prices plus the cart (after line discounts, before order ones). */
      var picked = 0;
      (this.lines() || []).forEach(function (l) { var lr = l.variant && l.variant.available && self.ladRow(l.piece, l.size); if (lr) picked += self.ladCents(lr[0]) * l.qty; });
      var sp = picked + (this.cartSub || 0), at = T.map(function (t) { return t.at * 100; }), k = -1;
      at.forEach(function (a, i) { if (sp >= a) k = i; });
      track.querySelectorAll('[data-pk-node]').forEach(function (nd) {
        var i = +nd.dataset.pkNode;
        nd.classList.toggle('is-on', i <= k);
        nd.classList.toggle('is-cur', i === k);
      });
      var pos = k < 0 ? 0 : k === top ? top : k + (sp - at[k]) / (at[k + 1] - at[k]);
      box.querySelector('[data-pk-ladder-fill]').style.width = (pos / top * 75) + '%';
      var msg = box.querySelector('[data-pk-ss-msg]');
      if (!msg) { track.insertAdjacentHTML('beforebegin', '<p class="pk-ladder__msg pk-ladder__ssmsg" data-pk-ss-msg aria-live="polite"></p>'); msg = box.querySelector('[data-pk-ss-msg]'); }
      var nx = T[k + 1];
      msg.innerHTML = k === top ? '<b>' + esc(T[top].label) + ' your order</b> unlocked'
        : sp > 0 ? 'Add <b>' + this.money(at[k + 1] - sp) + '</b> more for <b>' + esc(nx.off ? nx.label + ' your order' : 'free shipping') + '</b>'
        : 'Spend $' + T[0].at + ' for free shipping, $' + T[top].at + ' for ' + esc(T[top].label);
      var footEl = box.querySelector('[data-pk-ladder-foot]');
      footEl.textContent = this.cartSub ? 'Includes ' + this.money(this.cartSub) + ' already in your cart' : '';
      footEl.hidden = !this.cartSub;
      if (this._ssK !== undefined && k > this._ssK) {
        var pn = track.querySelector('[data-pk-node="' + k + '"]');
        if (pn) { pn.classList.remove('is-pop'); void pn.offsetWidth; pn.classList.add('is-pop'); setTimeout(function () { pn.classList.remove('is-pop'); }, 700); }
        if (k === top && !this._confetti) { this._confetti = true; this.ladConfetti(box); }
      }
      this._ssK = k;
      var grpM = this._ladHome && this._ladHome.next, labM = grpM && grpM.classList.contains('pk-pick__group') && grpM.querySelector('.pk-pick__label');
      if (labM && !grpM.querySelector('.pk-pick__mix')) labM.insertAdjacentHTML('afterend', '<p class="pk-pick__mix">Mix and match seat, back and chaise covers.</p>');
    }
    /* Prices are in US dollars; outside the US, convert at Shopify's rate (as renderTiers does). */
    ladCents(usd) { var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) || 1; return Math.round(usd * 100 * rate); }
    ladTier(n) { var b = this.L.breaks, t = 0; for (var i = 0; i < b.length; i++) { if (n >= b[i]) t = i; } return t; }
    /* The piece cards (28 Oct 2026, owner: fabric and colour first, then whole sofa or a few cushions, then sofa type
       and size, then one card per piece and size like Javvy's flavour cards). q holds a quantity per "piece|size". */
    ladInit() {
      var D = this.D;
      this.mode = 'sofa';
      this.sofaSize = D.defaultSize || 'M';
      /* Owner, 28 Oct 2026: no sofa type and size picker, so every size's cards always show. */
      this.showAll = true;
      /* Owner, 28 Oct 2026: starts with no covers picked unless the template sets default seat / back / chaise counts. */
      this.layout = (D.seat || D.back || D.chaise) ? { seat: +D.seat, back: +D.back, chaise: +D.chaise } : null;
      this.ladFill();
      /* Owner, 29 Oct 2026 (option C): one short list. Each row is a piece with its own size and quantity; customers can
         add a row for a different size (about 1 in 5 orders mixes sizes). Rows start at Small, the most-bought size. */
      var self = this;
      this.rows = [];
      ['seat', 'back', 'chaise'].forEach(function (p) { if (self.sizes[p] && self.sizes[p].length) self.rows.push({ p: p, z: self.ladSizeFor(p, 'S') }); });
      this.addEventListener('change', function (e) {
        var sel = e.target.closest && e.target.closest('[data-pk-row]');
        if (!sel) return;
        var r = self.rows[+sel.dataset.pkRow];
        if (!r || sel.value === r.z) return;
        var ok = r.p + '|' + r.z, nk = r.p + '|' + sel.value;
        if (self.q[ok]) { self.q[nk] = (self.q[nk] || 0) + self.q[ok]; delete self.q[ok]; }
        r.z = sel.value;
        self.render();
        var again = self.querySelector('[data-pk-row="' + sel.dataset.pkRow + '"]');
        if (again) again.focus({ preventScroll: true });
      });
      this.classList.add('pk-pick--pieces');
      /* Owner, 30 Oct 2026 (Design 1): one collapsible group per cover type. qc holds a quantity per "piece|size|colour"
         so each cover type can have its own colour; q (per "piece|size") is kept in step for the ladder and totals. */
      this.g1 = !!D.groups;
      if (this.g1) {
        var c0 = this.state.colour;
        this.qc = {};
        Object.keys(this.q).forEach(function (k) { if (self.q[k]) self.qc[k + '|' + c0] = self.q[k]; });
        this.tcol = {}; this.openType = 'seat'; this.showCol = ''; this.fit = {}; this.fopen = {};
        this._g1Fab = this.fabric.handle;
        this.classList.add('pk-pick--groups');
        this.addEventListener('input', function (e) {
          var t = e.target.closest && e.target.closest('[data-pk-g-fit]');
          if (!t) return;
          var p = t.dataset.pkGFit, pos = t.selectionStart;
          self.fit[p] = t.value;
          self.render();
          var again = self.querySelector('[data-pk-g-fit="' + p + '"]');
          if (again) { again.focus({ preventScroll: true }); try { again.setSelectionRange(pos, pos); } catch (err) { /* number inputs have no caret */ } }
        });
      }
    }
    g1Col(p) { return this.tcol[p] || this.state.colour; }
    g1Sync() {
      var q = {}, qc = this.qc;
      Object.keys(qc).forEach(function (k) { if (!qc[k]) return; var kp = k.split('|'), kk = kp[0] + '|' + kp[1]; q[kk] = (q[kk] || 0) + qc[k]; });
      this.q = q;
    }
    /* After an in-place fabric switch the old colour names may not exist, so every picked cover takes the new colour. */
    g1Fabric() {
      if (this._g1Fab === this.fabric.handle) return;
      this._g1Fab = this.fabric.handle;
      var self = this, nq = {};
      Object.keys(this.qc).forEach(function (k) { var kp = k.split('|'), nk = kp[0] + '|' + kp[1] + '|' + self.state.colour; nq[nk] = (nq[nk] || 0) + self.qc[k]; });
      this.qc = nq; this.tcol = {}; this.showCol = '';
      this.g1Sync();
    }
    /* Exact ranges from the size guide record (the drawer's data-pk-sg-data rows), for the cushion finder. */
    g1Ranges() {
      if (this._g1R !== undefined) return this._g1R;
      this._g1R = null;
      var raw = this.article && this.article.querySelector('[data-pk-sg-data]');
      if (!raw) return null;
      try {
        var d = JSON.parse(raw.textContent), out = {};
        if (!d.rows) return null;
        var rng = function (v) { var m = String(v || '').match(/([\d.]+)\s*[–-]\s*([\d.]+)/); return m ? [+m[1], +m[2]] : null; };
        d.rows.forEach(function (r) {
          var t = /seat/i.test(r.t) ? 'seat' : /back/i.test(r.t) ? 'back' : /chaise/i.test(r.t) ? 'chaise' : '';
          var z = /small/i.test(r.t) ? 'S' : /medium/i.test(r.t) ? 'M' : /large/i.test(r.t) ? 'L' : '';
          if (t && z) (out[t] = out[t] || {})[z] = { L: rng(r.l), W: rng(r.w) };
        });
        this._g1R = out;
      } catch (err) { console.error('[pdp-k] size guide rows unreadable for the cushion finder', err); }
      return this._g1R;
    }
    ladSizeFor(p, size) {
      var s = this.sizes[p] || [];
      if (s.indexOf(size) !== -1) return size;
      if (p === 'chaise' && size === 'S' && s.indexOf('M') !== -1) return 'M';
      return s[0] || size;
    }
    ladFillFor(layout, size) {
      var q = {}, self = this;
      ['seat', 'back', 'chaise'].forEach(function (p) { if (layout && layout[p] && self.sizes[p].length) q[p + '|' + self.ladSizeFor(p, size)] = layout[p]; });
      return q;
    }
    ladFill() { this.q = this.ladFillFor(this.layout, this.sofaSize); }
    ladSame(a, b) {
      var ka = Object.keys(a).filter(function (k) { return a[k]; }), kb = Object.keys(b).filter(function (k) { return b[k]; });
      return ka.length === kb.length && ka.every(function (k) { return a[k] === b[k]; });
    }
    ladKeys() {
      var self = this, out = [];
      ['seat', 'back', 'chaise'].forEach(function (p) { ['S', 'M', 'L'].forEach(function (z) { if (self.sizes[p].indexOf(z) !== -1) out.push(p + '|' + z); }); });
      return out;
    }
    ladLines() {
      var self = this, out = [];
      if (this.g1) {
        this.ladKeys().forEach(function (k) {
          Object.keys(self.qc).forEach(function (ck) {
            if (!self.qc[ck] || ck.indexOf(k + '|') !== 0) return;
            var kp = ck.split('|');
            out.push({ piece: kp[0], size: kp[1], colour: kp[2], qty: self.qc[ck], variant: self.variant(kp[0], kp[1], kp[2]) });
          });
        });
        return out;
      }
      this.ladKeys().forEach(function (k) {
        var n = self.q[k];
        if (!n) return;
        var kp = k.split('|');
        out.push({ piece: kp[0], size: kp[1], qty: n, variant: self.variant(kp[0], kp[1], self.state.colour) });
      });
      return out;
    }
    ladSel() { var q = this.q || {}; return Object.keys(q).reduce(function (a, k) { return a + (q[k] || 0); }, 0); }
    /* Clicks on the choice cards, sofa size, layout chips and piece cards. Returns true when handled. */
    ladClick(e) {
      var self = this;
      if (this.g1) {
        var gtz = e.target.closest('[data-pk-g-teaser]');
        if (gtz) { var lbx = this.querySelector('[data-pk-ladder]'); if (lbx) lbx.scrollIntoView({ behavior: 'smooth', block: 'center' }); return true; }
        var gb = e.target.closest('[data-pk-g-open]');
        if (gb) { var gp = gb.dataset.pkGOpen; this.openType = this.g1 ? gp : (this.openType === gp ? '' : gp); this.showCol = ''; this.render(); var gb2 = this.querySelector('[data-pk-g-open="' + gp + '"]'); if (gb2) gb2.focus({ preventScroll: true }); return true; }
        var gc = e.target.closest('[data-pk-g-col]');
        if (gc) { var cp = gc.dataset.pkGCol; this.showCol = this.showCol === cp ? '' : cp; this.render(); return true; }
        var gs = e.target.closest('[data-pk-g-pick]');
        if (gs) { var sp = gs.dataset.pkGPick, sv = gs.dataset.pkV; this.tcol[sp] = sv === this.state.colour ? null : sv; this.showCol = ''; this.render(); return true; }
        var gq = e.target.closest('[data-pk-g-q]');
        if (gq && !gq.disabled) {
          var qk = gq.dataset.pkGQ, qd = +gq.dataset.pkD || 0, qp = qk.split('|'), ck = qk + '|' + this.g1Col(qp[0]);
          this.qc[ck] = Math.max(0, Math.min(20, (this.qc[ck] || 0) + qd));
          if (!this.qc[ck]) delete this.qc[ck];
          this.g1Sync();
          this._focus = { piece: qp[0], size: qp[1] };
          this.render();
          var qa = this.querySelector('[data-pk-g-q="' + qk + '"][data-pk-d="' + qd + '"]') || this.querySelector('[data-pk-g-q="' + qk + '"]');
          if (qa && !window.matchMedia('(pointer: coarse)').matches) qa.focus({ preventScroll: true });
          return true;
        }
        var gf = e.target.closest('[data-pk-g-find]');
        if (gf) { var fp = gf.dataset.pkGFind; this.fopen[fp] = true; this.render(); var fi = this.querySelector('[data-pk-g-fit="' + fp + '"]'); if (fi) fi.focus(); return true; }
        var gn = e.target.closest('[data-pk-g-notify]');
        if (gn) { this.notify([{ id: +gn.dataset.pkGNotify, label: gn.dataset.pkLabel }]); return true; }
        var gg = e.target.closest('[data-pk-g-guide]');
        if (gg) {
          /* The drawer opens from the document listener (data-pk-drawer-open); then show this cover type's tab. */
          var tab = gg.dataset.pkGGuide, did = gg.getAttribute('data-pk-drawer-open');
          setTimeout(function () { var tb = document.querySelector('#' + did + ' [data-pk-sg-tab="' + tab + '"]'); if (tb) tb.click(); }, 30);
          return true;
        }
      }
      var mode = e.target.closest('[data-pk-mode]');
      if (mode) {
        var m = mode.dataset.pkMode;
        if (m === this.mode) return true;
        this.mode = m;
        if (m === 'few') { this.q = {}; this.showAll = true; }
        else { if (!this.layout) this.layout = { seat: 3, back: 3, chaise: 0 }; this.ladFill(); }
        this._focus = { piece: 'seat', size: this.ladSizeFor('seat', this.sofaSize) };
        this.render();
        return true;
      }
      var lay = e.target.closest('[data-pk-layouts] .pk-chip');
      if (lay) {
        this.mode = 'sofa';
        this.layout = { seat: +lay.dataset.seat, back: +lay.dataset.back, chaise: +lay.dataset.chaise };
        this.ladFill();
        this._focus = { piece: 'seat', size: this.ladSizeFor('seat', this.sofaSize) };
        this.render();
        return true;
      }
      var ss = e.target.closest('[data-pk-sofa-size]');
      if (ss) {
        var wasLayout = this.layout && this.ladSame(this.q, this.ladFillFor(this.layout, this.sofaSize));
        this.sofaSize = ss.dataset.pkSofaSize;
        if (wasLayout) this.ladFill();
        this._focus = { piece: 'seat', size: this.ladSizeFor('seat', this.sofaSize) };
        this.render();
        return true;
      }
      var ropt = e.target.closest('[data-pk-ropt]');
      if (ropt) {
        if (ropt.disabled) return true;
        var ri = +ropt.dataset.pkR, row = this.rows[ri], nz = ropt.dataset.pkRopt;
        if (row && nz !== row.z) {
          var ok = row.p + '|' + row.z, nk = row.p + '|' + nz;
          if (this.q[ok]) { this.q[nk] = (this.q[nk] || 0) + this.q[ok]; delete this.q[ok]; }
          row.z = nz;
        }
        if (row) this._focus = { piece: row.p, size: row.z };
        this._ddOpen = null;
        this.render();
        var rb = this.querySelector('[data-pk-ddbtn="r' + ri + '"]');
        if (rb) rb.focus({ preventScroll: true });
        return true;
      }
      var nb = e.target.closest('[data-pk-notify]');
      if (nb) { this.notify(this.notifyItems([nb.dataset.pkNotify])); return true; }
      if (e.target.closest('[data-pk-addsize]')) { this._addOpen = !this._addOpen; this.render(); return true; }
      var addp = e.target.closest('[data-pk-addp]');
      if (addp) {
        var ap = addp.dataset.pkAddp, used = this.rows.filter(function (r) { return r.p === ap; }).map(function (r) { return r.z; });
        var free = (this.sizes[ap] || []).filter(function (z) { return used.indexOf(z) === -1; });
        if (free.length) {
          var at = 0;
          this.rows.forEach(function (r, i) { if (r.p === ap) at = i + 1; });
          this.rows.splice(at, 0, { p: ap, z: free[0] });
          this._focus = { piece: ap, size: free[0] };
        }
        this._addOpen = false;
        this.render();
        var ns = this.querySelector('[data-pk-row="' + at + '"]');
        if (ns) ns.focus({ preventScroll: true });
        return true;
      }
      var rm = e.target.closest('[data-pk-rmrow]');
      if (rm) {
        var rr = this.rows[+rm.dataset.pkRmrow];
        if (rr) { delete this.q[rr.p + '|' + rr.z]; this.rows.splice(+rm.dataset.pkRmrow, 1); }
        this.render();
        return true;
      }
      var card = e.target.closest('[data-pk-card]');
      if (card && !card.disabled) {
        var k = card.dataset.pkCard, d = +card.dataset.pkD || 0;
        this.q[k] = Math.max(0, Math.min(20, (this.q[k] || 0) + d));
        if (!this.q[k]) delete this.q[k];
        var kp = k.split('|');
        this._focus = { piece: kp[0], size: kp[1] };
        this.render();
        var again = this.querySelector('[data-pk-card="' + k + '"][data-pk-d="' + d + '"]') || this.querySelector('[data-pk-card="' + k + '"]');
        if (again && !window.matchMedia('(pointer: coarse)').matches) again.focus({ preventScroll: true });
        return true;
      }
      if (e.target.closest('[data-pk-pcs-more]')) { this.showAll = !this.showAll; this.render(); return true; }
      return false;
    }
    /* Size guide drawings of each cushion (sections/pdp-k-main.liquid, pk-sg__svg), filled with the colour's fabric photo.
       S, M and L are drawn at 82%, 91% and 100%. */
    ladArt(p, z, col, uid) {
      /* Owner, 28 Oct 2026: the sofa icons from the old picker rows (variant module metafield), the piece shaded dark. */
      var icon = this.D.icons && this.D.icons[p];
      if (icon) return '<img class="pk-pc__icon" src="' + esc(icon) + '" alt="" loading="lazy" width="160" height="132">';
      var sc = { S: 0.82, M: 0.91, L: 1 }[z] || 1;
      /* clipPath children cannot be groups, so the S/M/L scale goes on each shape. */
      var tr = ' transform="translate(100 66) scale(' + sc + ') translate(-100 -66)"';
      var shapes = {
        seat: ['<rect' + tr + ' x="12" y="14" width="176" height="104" rx="18"/>', '<rect' + tr + ' x="24" y="26" width="152" height="80" rx="11"/>'],
        back: ['<path' + tr + ' d="M14 20Q100 4 186 20Q198 66 186 112Q100 128 14 112Q2 66 14 20Z"/>', '<path' + tr + ' d="M27 30Q100 16 173 30Q183 66 173 102Q100 116 27 102Q17 66 27 30Z"/>'],
        chaise: ['<rect' + tr + ' x="58" y="4" width="84" height="124" rx="14"/>', '<rect' + tr + ' x="67" y="13" width="66" height="106" rx="9"/>']
      };
      var sh = shapes[p];
      var id = 'pkc-' + uid + '-' + p + z;
      /* Colour: the swatch colour (k_colour_hex). Texture: the fabric's tile photo laid over it. The colour photos are
         whole-sofa renders, so they are only used when a colour has no hex. */
      var tex = this.fabric.image ? String(this.fabric.image).replace(/_240x240\./, '_480x480.') : '';
      var fill = '<g clip-path="url(#' + id + ')">';
      if (col && col.hex) {
        fill += '<rect width="200" height="132" fill="' + esc(col.hex) + '"/>';
        if (tex) fill += '<image class="pk-pc__tex" href="' + esc(tex) + '" x="0" y="0" width="200" height="132" preserveAspectRatio="xMidYMid slice"/>';
      } else if (col && col.swatch) {
        fill += '<image href="' + esc(String(col.swatch).replace(/([?&]width=)\d+/, '$1360')) + '" x="0" y="0" width="200" height="132" preserveAspectRatio="xMidYMid slice"/>';
      } else {
        fill += '<rect width="200" height="132" fill="#ebe7df"/>';
      }
      fill += '</g>';
      return '<svg class="pk-pc__art" viewBox="0 0 200 132" aria-hidden="true" focusable="false"><defs><clipPath id="' + id + '">' + sh[0] + '</clipPath></defs>' + fill +
        '<g fill="none"><g class="pk-pc__edge">' + sh[0] + '</g><g class="pk-pc__seam">' + sh[1] + '</g></g></svg>';
    }
    renderPieces(lad) {
      var box = this.querySelector('[data-pk-pcs]');
      if (!box || !this.L) return;
      if (this.g1) { this.renderGroups(box, lad); return; }
      var self = this, D = this.D, q = this.q, ti = lad ? lad.ti : 0;
      this.querySelectorAll('[data-pk-mode]').forEach(function (b) { var on = b.dataset.pkMode === self.mode; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
      var sofa = this.querySelector('[data-pk-sofa]');
      if (sofa) sofa.hidden = this.mode !== 'sofa';
      this.classList.toggle('pk-pick--sofa', this.mode === 'sofa');
      var gg = this.querySelector('[data-pk-grid-guide]');
      if (gg) gg.hidden = false;
      this.querySelectorAll('[data-pk-layouts] .pk-chip').forEach(function (b) {
        var on = self.mode === 'sofa' && self.ladSame(q, self.ladFillFor({ seat: +b.dataset.seat, back: +b.dataset.back, chaise: +b.dataset.chaise }, self.sofaSize));
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
      });
      var szBox = this.querySelector('[data-pk-sofa-sizes]');
      if (szBox) szBox.innerHTML = ['S', 'M', 'L'].map(function (z) { var on = z === self.sofaSize; return '<button type="button" class="pk-size' + (on ? ' is-active' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + SIZE_NAMES[z] + '" data-pk-sofa-size="' + z + '">' + z + '</button>'; }).join('');
      var dimsEl = this.querySelector('[data-pk-sofa-dims]');
      if (dimsEl) {
        var ds = [['seat', 'Seat'], ['back', 'Back']].map(function (x) { var dm = (D.dims[x[0]] || {})[self.sofaSize]; return dm ? x[1] + ': ' + dm : ''; }).filter(Boolean);
        dimsEl.textContent = ds.length ? (SIZE_NAMES[this.sofaSize] || this.sofaSize) + ' fits ' + ds.join(' · ') : '';
      }
      var ln = this.ladLine();
      var few = this.querySelector('[data-pk-few-from]');
      if (few && ln) { var lo = null; Object.keys(ln).forEach(function (k) { if (lo === null || ln[k][0] < lo) lo = ln[k][0]; }); few.textContent = '. From ' + this.money(this.ladCents(lo)) + ' each'; }
      var col = this.fabric.colours.find(function (c) { return c.name === self.state.colour; });
      var uid = (this.dataset.section || 'x').replace(/[^\w-]/g, '');
      var names = { seat: 'Seat Cover', back: 'Back Cover', chaise: 'Chaise Cover' };
      var rows = this.rows || [];
      /* Any piece in q without a row (template defaults) gets one, so nothing picked is ever hidden. */
      Object.keys(q).forEach(function (k) {
        if (!q[k]) return;
        var kp = k.split('|');
        if (!rows.some(function (r) { return r.p === kp[0] && r.z === kp[1]; })) {
          var at = rows.length;
          rows.forEach(function (r, i) { if (r.p === kp[0]) at = i + 1; });
          rows.splice(at, 0, { p: kp[0], z: kp[1] });
        }
      });
      /* The size list names the measurement that changes between sizes (length for seats and backs, width for chaises). */
      var dimLabel = function (p, z) {
        var parts = String((D.dims[p] || {})[z] || '').split(/\s*×\s*/);
        var all = self.sizes[p].map(function (zz) { return String((D.dims[p] || {})[zz] || '').split(/\s*×\s*/); });
        var keep = parts.filter(function (part, i) { return all.some(function (o) { return o[i] !== part; }); });
        /* Size guide research, 29 Oct 2026: only the side-to-side range changes between sizes, so show that one number
           without the L / W letters (they mean different directions on the seat and the chaise). */
        return (keep.length ? keep : parts).map(function (x) { return x.replace(/^[LW]\s*/, ''); }).join(' × ');
      };
      var seen = {};
      /* Owner, 29 Oct 2026 (option C, from past Intelligems tests: one form, free piece picker, progress near the button).
         Row: sofa icon, piece name and price per piece at the current tier, size dropdown, round − / + buttons. */
      box.innerHTML = '<div class="pk-lrs">' + rows.map(function (r, i) {
        var p = r.p, z = r.z, k = p + '|' + z, n = q[k] || 0;
        var extra = !!seen[p];
        seen[p] = true;
        var v = self.variant(p, z, self.state.colour), lr = self.ladRow(p, z);
        var out = !v || !v.available;
        var now = lr ? self.money(self.ladCents(lr[ti])) : v ? self.money(v.price) : '';
        /* Owner, 30 Oct 2026: a sold-out size says so and offers Notify Me (Klaviyo back in stock, assets/pdp-bis.js). */
        var notify = out && v && !n;
        var label = names[p].toLowerCase() + ', ' + (SIZE_NAMES[z] || z);
        var taken = rows.filter(function (o, j) { return j !== i && o.p === p; }).map(function (o) { return o.z; });
        /* Owner, 29 Oct 2026: the same size dropdown as the mats and blankets (name and measurements, price on the right). */
        var open = self._ddOpen === 'r' + i;
        var opts = self.sizes[p].map(function (zz) {
          var vv = self.variant(p, zz, self.state.colour), so = !vv || !vv.available, used = taken.indexOf(zz) !== -1, on = zz === z;
          var lz = self.ladRow(p, zz);
          var right = so ? '<span class="pk-dd__out">Sold out</span>' : used ? '<span class="pk-dd__out">In your list</span>'
            : '<span class="pk-dd__now">' + (lz ? self.money(self.ladCents(lz[ti])) : vv ? self.money(vv.price) : '') + '</span>' + (lz && ti > 0 ? '<s class="pk-dd__was">' + self.money(self.ladCents(lz[0])) + '</s>' : '');
          var dis = !on && (so || used);
          return '<button type="button" role="option" aria-selected="' + on + '" class="pk-dd__opt' + (on ? ' is-on' : '') + (dis ? ' is-out' : '') + '" data-pk-ropt="' + zz + '" data-pk-r="' + i + '"' + (dis ? ' disabled' : '') + '><span class="pk-dd__txt"><span class="pk-dd__name">' + (SIZE_NAMES[zz] || zz) + '</span><span class="pk-dd__dims">' + 'Fits ' + esc(dimLabel(p, zz)) + ' cushions</span></span><span class="pk-dd__price">' + right + '</span></button>';
        }).join('');
        var chev = '<svg class="pk-sel__chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg>';
        var dd = '<div class="pk-dd' + (open ? ' is-open' : '') + '"><button type="button" class="pk-sel pk-dd__btn" aria-haspopup="listbox" aria-expanded="' + open + '" aria-label="' + names[p] + ' size: ' + (SIZE_NAMES[z] || z) + '" data-pk-ddbtn="r' + i + '"><span class="pk-dd__val pk-dd__val--line"><span class="pk-dd__name">' + (SIZE_NAMES[z] || z) + '</span><span class="pk-dd__dims">· ' + esc(dimLabel(p, z)) + '</span></span>' + chev + '</button>' +
          '<div class="pk-dd__list" role="listbox" aria-label="' + names[p] + ' size"' + (open ? '' : ' hidden') + '>' + opts + '</div></div>';
        return '<div class="pk-lr' + (n ? ' is-on' : '') + (out ? ' is-out' : '') + '">' +
          '<span class="pk-lr__icon">' + self.ladArt(p, z, null, '') + '</span>' +
          '<div class="pk-lr__main"><div class="pk-lr__top"><span class="pk-lr__name">' + names[p] + '</span><span class="pk-lr__price">' + (out ? '<span class="pk-lr__so">Sold out</span>' : now + '<small>/ea</small>') + '</span></div>' +
          '<div class="pk-lr__selrow">' + dd +
          (extra ? '<button type="button" class="pk-lr__rm" data-pk-rmrow="' + i + '" aria-label="Remove ' + label + '"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6"/></svg></button>' : '') + '</div></div>' +
          (notify ? '<button type="button" class="pk-lr__notify" data-pk-notify="' + k + '" aria-label="Notify me when ' + label + ' is back in stock">Notify me</button>' :
          '<div class="pk-pc__step pk-lr__step" role="group" aria-label="' + label + ' quantity"><button type="button" data-pk-card="' + k + '" data-pk-d="-1" aria-label="One fewer ' + label + '"' + (n ? '' : ' disabled') + '><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8"/></svg></button><output aria-live="polite">' + n + '</output><button type="button" data-pk-card="' + k + '" data-pk-d="1" aria-label="One more ' + label + '"' + (out ? ' disabled' : '') + '><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6 2v8"/></svg></button></div>') +
          '</div>';
      }).join('') + '</div>';
      var addable = ['seat', 'back', 'chaise'].filter(function (p) {
        var used = rows.filter(function (r) { return r.p === p; }).map(function (r) { return r.z; });
        return (self.sizes[p] || []).some(function (z) { return used.indexOf(z) === -1; });
      });
      if (addable.length) {
        box.innerHTML += '<div class="pk-lr__add"><button type="button" class="pk-lr__addbtn" data-pk-addsize aria-expanded="' + !!this._addOpen + '">+ Add a different size</button>' +
          (this._addOpen ? '<span class="pk-lr__addto">' + addable.map(function (p) { return '<button type="button" class="pk-chip" data-pk-addp="' + p + '">' + names[p].replace(' Cover', '') + '</button>'; }).join('') + '</span>' : '') + '</div>';
      }
      var more = this.querySelector('[data-pk-pcs-more]');
      if (more) more.hidden = true;
    }
    /* Owner, 30 Oct 2026 (Design 1): one group per cover type. Closed: picture, name, "From $X/ea" or what is in it.
       Open: "Color: X · Change", a line per size (measurement, price, ADD + or − n +), then "Not sure which size?".
       On desktop every group is open and its sizes sit as cards, three across. */
    renderGroups(box, lad) {
      this.g1Fabric();
      var self = this, D = this.D, ti = lad ? lad.ti : 0, qc = this.qc, top = this.state.colour;
      var names = { seat: 'Seat covers', back: 'Back covers', chaise: 'Chaise covers' }, one = { seat: 'Seat cover', back: 'Back cover', chaise: 'Chaise cover' };
      var sid = (this.dataset.section || '');
      var rg = this.g1Ranges() || {};
      var sizeUp = !/smaller size/i.test((this.article.querySelector('.pk-sg__onote') || {}).textContent || '');
      var dimLabel = function (p, z) {
        var parts = String((D.dims[p] || {})[z] || '').split(/\s*×\s*/);
        var all = self.sizes[p].map(function (zz) { return String((D.dims[p] || {})[zz] || '').split(/\s*×\s*/); });
        var keep = parts.filter(function (part, i) { return all.some(function (o) { return o[i] !== part; }); });
        return (keep.length ? keep : parts).map(function (x) { return x.replace(/^[LW]\s*/, ''); }).join(' × ');
      };
      var seats = Object.keys(qc).reduce(function (t, k) { return t + (k.indexOf('seat|') === 0 ? qc[k] : 0); }, 0);
      var tiles = [], short = { seat: 'Seat', back: 'Back', chaise: 'Chaise' };
      var types = ['seat', 'back', 'chaise'].filter(function (p) { return self.sizes[p] && self.sizes[p].length; });
      if (types.indexOf(this.openType) === -1) this.openType = types[0];
      var panels = types.map(function (p) {
        var col = self.g1Col(p), open = self.openType === p, sizes = self.sizes[p];
        var mine = Object.keys(qc).filter(function (k) { return qc[k] && k.indexOf(p + '|') === 0; });
        var cnt = mine.reduce(function (t, k) { return t + qc[k]; }, 0);
        var cols = {}; mine.forEach(function (k) { cols[k.split('|')[2]] = 1; });
        var named = Object.keys(cols).length > 1;
        var parts = [];
        sizes.forEach(function (z) { mine.forEach(function (k) { var kp = k.split('|'); if (kp[1] === z) parts.push(qc[k] + ' ' + (SIZE_NAMES[z] || z) + (named ? ' ' + kp[2] : '')); }); });
        if (cnt && !named) parts = [parts.join(', ') + ' · ' + Object.keys(cols)[0]];
        var lows = sizes.map(function (z) { var lr = self.ladRow(p, z); return lr ? lr[ti] : null; }).filter(function (x) { return x !== null; });
        var from = lows.length ? self.money(self.ladCents(Math.min.apply(null, lows))) : '';
        var nudge = ''; /* Owner, 30 Oct 2026: back-cushion line removed. */
        var sub = (cnt ? '<b>' + cnt + ' added</b> · ' + esc(parts.join(', ')) : (from ? 'From ' + from + '<small>/ea</small> · ' : '') + sizes.length + ' sizes') + nudge;
        /* Colour line. */
        var swatches = self.fabric.colours.map(function (c) {
          var any = self.fabric.variants.some(function (v) { return v.colour === c.name && v.available; });
          var bg = c.hex ? 'background:' + esc(c.hex) : c.swatch ? 'background-image:url(' + esc(c.swatch) + ')' : '';
          return '<button type="button" class="pk-g__sw' + (c.name === col ? ' is-on' : '') + (any ? '' : ' is-out') + '" style="' + bg + '" data-pk-g-pick="' + p + '" data-pk-v="' + esc(c.name) + '" aria-label="' + esc(c.name) + (any ? '' : ', sold out') + '" aria-pressed="' + (c.name === col) + '"' + (any ? '' : ' disabled') + '></button>';
        }).join('');
        var cobj = self.fabric.colours.find(function (c) { return c.name === col; }) || {};
        var chip = cobj.hex ? 'background:' + esc(cobj.hex) : cobj.swatch ? 'background-image:url(' + esc(cobj.swatch) + ')' : '';
        var colLine = '<div class="pk-g__col"><span><b>Color:</b><i style="' + chip + '"></i>' + esc(col) + '</span> · <button type="button" class="pk-g__link" data-pk-g-col="' + p + '" aria-expanded="' + (self.showCol === p) + '">' + (self.showCol === p ? 'Done' : 'Change') + '</button>' +
          '<button type="button" class="pk-g__link pk-g__chart" data-pk-drawer-open="pk-size-' + esc(sid) + '" data-pk-g-guide="' + p + '"><svg viewBox="0 0 16 16" aria-hidden="true"><rect x="1" y="5" width="14" height="6" rx="1"/><path d="M4 5v2.5M7 5v3.5M10 5v2.5M13 5v3.5"/></svg>Size chart</button></div>' +
          (self.showCol === p ? '<div class="pk-g__sws" role="group" aria-label="' + one[p] + ' color">' + swatches + '</div>' : '');
        /* Cushion finder: seats and backs by length, chaises by width (both chaise sizes share one length). */
        var dimKey = p === 'chaise' ? 'W' : 'L', what = p === 'chaise' ? 'chaise width' : 'cushion length', unit = p === 'chaise' ? 'wide' : 'long';
        var raw = self.fit[p] || '', v = parseFloat(String(raw).replace(',', '.')), hits = [], msg = '';
        var rr = rg[p] || {};
        if (v > 0 && Object.keys(rr).length) {
          sizes.forEach(function (z) { var r = rr[z] && rr[z][dimKey]; if (r && v >= r[0] && v <= r[1]) hits.push(z); });
          var lo = rr[sizes[0]] && rr[sizes[0]][dimKey], hi = rr[sizes[sizes.length - 1]] && rr[sizes[sizes.length - 1]][dimKey];
          if (!hits.length) msg = lo && v < lo[0] ? 'That is smaller than our ' + SIZE_NAMES[sizes[0]] + ' (from ' + lo[0] + '″). Message us and we\'ll help.' : 'That is bigger than our ' + SIZE_NAMES[sizes[sizes.length - 1]] + (hi ? ' (up to ' + hi[1] + '″)' : '') + '. Message us and we\'ll help.';
          else if (hits.length > 1) { var pick = sizeUp ? hits[hits.length - 1] : hits[0]; msg = v + '″ is right between ' + SIZE_NAMES[hits[0]] + ' and ' + SIZE_NAMES[hits[hits.length - 1]] + '. Pick <b>' + SIZE_NAMES[pick] + '</b>.'; hits = [pick]; }
          else msg = '<b>' + SIZE_NAMES[hits[0]] + '</b> fits a ' + v + '″-' + unit + ' ' + (p === 'chaise' ? 'chaise' : 'cushion') + '.';
          if (hits.length) { var hv = self.variant(p, hits[0], col); if (!hv || !hv.available) msg += ' It is sold out in ' + esc(col) + ', so pick another color.'; }
        }
        var fOpen = self.fopen[p] || raw !== '';
        var guide = '<button type="button" class="pk-g__link" data-pk-drawer-open="pk-size-' + esc(sid) + '" data-pk-g-guide="' + p + '">Size guide</button>';
        var finder = fOpen
          ? '<div class="pk-g__fit"><div class="pk-g__fitrow"><label>My ' + (p === 'chaise' ? 'chaise' : 'cushion') + ' is <input type="text" inputmode="decimal" autocomplete="off" data-pk-g-fit="' + p + '" value="' + esc(raw) + '" aria-label="' + what + ' in inches">″ ' + unit + '</label>' + guide + '</div>' + (msg ? '<p class="pk-g__fitmsg" aria-live="polite">' + msg + '</p>' : '') + '</div>'
          : '<div class="pk-g__find"><button type="button" class="pk-g__link pk-g__findbtn" data-pk-g-find="' + p + '">Not sure which size? <u>Enter your ' + what + '</u></button></div>';
        /* Size lines. */
        var lines = sizes.map(function (z) {
          var key = p + '|' + z, n = qc[key + '|' + col] || 0, v2 = self.variant(p, z, col), out = !v2 || !v2.available, lr = self.ladRow(p, z), hit = hits.indexOf(z) !== -1;
          var price = lr ? self.money(self.ladCents(lr[ti])) : v2 ? self.money(v2.price) : '';
          var wasP = self.SS && lr && lr[4] > lr[0] ? self.money(self.ladCents(lr[4])) : '';
          var others = mine.filter(function (k) { return k.indexOf(key + '|') === 0 && k !== key + '|' + col; }).map(function (k) { return qc[k] + ' in ' + k.split('|')[2]; });
          var label = one[p].toLowerCase() + ', ' + (SIZE_NAMES[z] || z) + ', ' + col;
          var ctl = n ? '<div class="pk-g__step" role="group" aria-label="' + esc(label) + ' quantity"><button type="button" class="pk-g__minus" data-pk-g-q="' + key + '" data-pk-d="-1" aria-label="One fewer ' + esc(label) + '">−</button><output aria-live="polite">' + n + '</output><button type="button" class="pk-g__plus" data-pk-g-q="' + key + '" data-pk-d="1" aria-label="One more ' + esc(label) + '"' + (out ? ' disabled' : '') + '>+</button></div>'
            : out ? (v2 ? '<button type="button" class="pk-g__notify" data-pk-g-notify="' + v2.id + '" data-pk-label="' + esc([col, one[p], SIZE_NAMES[z] || z].join(' · ')) + '">Notify me</button>' : '<span class="pk-g__na">Not available</span>')
            : '<button type="button" class="pk-g__add" data-pk-g-q="' + key + '" data-pk-d="1" aria-label="Add a ' + esc(label) + '">Add +</button>';
          return '<div class="pk-g__line' + (n ? ' is-on' : '') + (out ? ' is-out' : '') + (hit ? ' is-fit' : '') + '">' +
            '<span class="pk-g__art">' + (self.g1SizeArt(p, z, rr, sizes, cobj.hex) || self.ladArt(p, z, null, '')) + '</span>' +
            '<div class="pk-g__info"><div class="pk-g__size"><b>' + (SIZE_NAMES[z] || z) + '</b><span class="pk-g__sep"> · </span>' + esc(dimLabel(p, z)) + (p === 'chaise' ? ' wide' : ' long') + '</div>' +
            '<div class="pk-g__price">' + (price ? price + '<small>/ea</small>' + (wasP ? ' <s>' + wasP + '</s>' : '') : '') + '</div>' +
            (hit ? '<span class="pk-g__badge">Fits your ' + (p === 'chaise' ? 'chaise' : 'cushion') + '</span>' : '') +
            (out && !n ? '<span class="pk-g__so">Sold out in ' + esc(col) + '</span>' : '') +
            /* Owner, 30 Oct 2026 ("very confusing"): the "Also 1 in Cream" line is removed; the row summary names each colour. */ '</div>' + ctl + '</div>';
        }).join('');
        tiles.push('<button type="button" class="pk-gt__tile' + (open ? ' is-on' : '') + '" role="tab" data-pk-g-open="' + p + '" aria-selected="' + open + '" aria-controls="pk-g-' + esc(sid) + '-' + p + '">' +
          (cnt ? '<em class="pk-gt__pill" aria-hidden="true">' + cnt + '</em>' : '') +
          '<span class="pk-gt__art">' + self.ladArt(p, 'M', null, '') + '</span><span class="pk-gt__name">' + short[p] + '<span class="pk-sr"> covers' + (cnt ? ', ' + cnt + ' added' : '') + '</span></span></button>');
        if (!open) return '';
        var lrStrip = (p === 'chaise' ? '<div class="pk-g__lr"><span class="pk-g__lrpic">' + self.ladArt('chaise', 'M', null, '') + '<small>Left</small></span><span class="pk-g__lrpic is-flip">' + self.ladArt('chaise', 'M', null, '') + '<small>Right</small></span><p><b>Fits a left or right chaise.</b> The same cover works on either side.</p></div>' : '');
        return '<div class="pk-g is-open' + (cnt ? ' is-on' : '') + '">' +
          '<div class="pk-g__body" id="pk-g-' + esc(sid) + '-' + p + '" role="tabpanel" aria-label="' + names[p] + '">' + (named ? '<div class="pk-g__sum">' + sub + '</div>' : '') + colLine +
          '<div class="pk-g__lines">' + lines + '</div>' + lrStrip + finder + '</div></div>';
      }).join('');
      var teaser = '', lnT = this.ladLine();
      if (lnT && this.L) {
        var tTop = this.L.breaks.length - 1, tLow = Object.keys(lnT).reduce(function (m, k) { return Math.min(m, lnT[k][tTop]); }, Infinity);
        if (isFinite(tLow)) teaser = '<button type="button" class="pk-gteaser' + (lad && lad.n > 0 && lad.ti > 0 ? ' is-lit' : '') + '" data-pk-g-teaser>' +
          '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8.6 1.5H14a.5.5 0 0 1 .5.5v5.4a.5.5 0 0 1-.15.35l-6.6 6.6a.5.5 0 0 1-.7 0L1.65 9a.5.5 0 0 1 0-.7l6.6-6.6a.5.5 0 0 1 .35-.15Z"/><circle cx="11.2" cy="4.8" r="1.2"/></svg>' +
          '<span><b>Buy more. Save more:</b> ' + this.L.breaks[tTop] + '+ covers from ' + this.money(this.ladCents(tLow)) + '<small>/ea</small></span></button>';
      }
      box.innerHTML = '<div class="pk-gs pk-gs--tiles" data-open-i="' + types.indexOf(this.openType) + '" data-n="' + types.length + '"><div class="pk-gt" role="tablist" aria-label="Cover type">' + tiles.join('') + '</div>' + panels + '</div>';
      var more = this.querySelector('[data-pk-pcs-more]');
      if (more) more.hidden = true;
    }
    /* Back in stock items for "piece|size" keys in the shown colour (sold-out sizes only). */
    notifyItems(keys) {
      var self = this, names = { seat: 'Seat cover', back: 'Back cover', chaise: 'Chaise cover' };
      return keys.map(function (k) {
        var kp = k.split('|'), v = self.variant(kp[0], kp[1], self.state.colour);
        return v && !v.available ? { id: v.id, label: [self.state.colour, names[kp[0]] || kp[0], SIZE_NAMES[kp[1]] || kp[1]].join(' · ') } : null;
      }).filter(Boolean);
    }
    notify(items) {
      if (!items.length) return;
      if (window.NolanBIS && typeof window.NolanBIS.open === 'function') window.NolanBIS.open(items);
      else console.error('[pdp-k] back in stock sign-up is not loaded (assets/pdp-bis.js)');
    }
    ladState() {
      if (!this.ladLine()) return null;
      var st = this.state, self = this, sel = 0;
      if (this.q) sel = this.ladSel();
      else ['seat', 'back', 'chaise'].forEach(function (p) { if (self.sizes[p].length) sel += st[p].qty; });
      var n = sel + this.cartPieces;
      return { sel: sel, n: n, ti: this.ladTier(n), top: this.L.breaks.length - 1 };
    }
    ladName(f) { return f.piece.charAt(0).toUpperCase() + f.piece.slice(1) + ' ' + f.size; }
    /* Owner, 29 Oct 2026: the ladder and the savings line quote the shopper's own pieces, so nobody reads one price as
       the price of every cushion. One exact price when every piece in the list costs the same at tier i, else "from"
       the cheapest. Rows with a quantity count; with none yet, the first row (the seat) stands in. */
    ladList(i) {
      var self = this, rows = this.rows || [], q = this.q || {};
      var on = rows.filter(function (r) { return q[r.p + '|' + r.z]; });
      var pr = (on.length ? on : rows.slice(0, 1)).map(function (r) { var lr = self.ladRow(r.p, r.z); return lr ? lr[i] : null; }).filter(function (x) { return x !== null; });
      if (!pr.length) return null;
      var lo = Math.min.apply(null, pr);
      return { lo: lo, same: pr.every(function (x) { return x === lo; }) };
    }
    /* Sofa cover pieces already in the cart count toward the tier. Re-read after every cart change. */
    watchCart() {
      var self = this, L = this.L;
      var load = function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          var n = 0;
          (c.items || []).forEach(function (it) {
            if (!L.products[it.handle]) return;
            var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' ') || it.variant_title || '';
            if (/(^|\s)(Seat|Back|Chaise) Cover\b/.test(opts)) n += it.quantity;
          });
          var tot = c.total_price || 0, sub = c.items_subtotal_price || 0;
          self._cart = c;
          if (self.SS || (c.attributes && c.attributes._nolan_offer === 'ss')) pkOfferSync(c).then(function (c2) { if (c2) self._cart = c2; }).catch(function (err) { console.error('[pdp-k] could not save the offer group on the cart', err); });
          if (n !== self.cartPieces || tot !== self.cartTotal || sub !== self.cartSub) { self.cartPieces = n; self.cartTotal = tot; self.cartSub = sub; self.render(); }
        }).catch(function (err) { console.error('[pdp-k] could not read the cart for piece pricing', err); });
      };
      load();
      document.addEventListener('cart:updated', load);
      if (window.EventBus && typeof window.EventBus.on === 'function') window.EventBus.on('cart:changed', load);
      window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
    }
    renderLadder(lad) {
      var box = this.querySelector('[data-pk-ladder]');
      var nudge = this.querySelector('[data-pk-nudge]');
      if (box) box.hidden = !lad;
      if (nudge) nudge.hidden = !lad;
      if (!lad || !box) return;
      if (this.g1 && !this._ladMoved) { var grpL = box.closest('.pk-pick__group'); if (grpL) { grpL.parentNode.insertBefore(box, grpL); box.classList.add('pk-ladder--top'); this._ladMoved = true; } }
      if (this.SS) { this.ssRender(box); return; }
      var self = this, L = this.L, top = lad.top;
      /* Owner, 30 Oct 2026 ("show the price ladder that depends on what they select seat or back or chaise"): the ladder
         shows the exact tier prices of the piece and size picked last; before any pick, the first row (the default). */
      var rws = this.rows || [], qq = this.q || {}, f = this._focus;
      if (!this.g1 && rws.length && !rws.some(function (r) { return r.p === f.piece && r.z === f.size; })) {
        var fr0 = rws.find(function (r) { return qq[r.p + '|' + r.z]; }) || rws[0];
        f = { piece: fr0.p, size: fr0.z };
      }
      var fr = this.ladRow(f.piece, f.size);
      if (!fr) { f = { piece: 'seat', size: this.sofaSize || this.state.seat.size }; fr = this.ladRow(f.piece, f.size); }
      if (!fr) { box.hidden = true; return; }
      /* Owner, 30 Oct 2026 ("Remove this too"): no "Price per cover for: ..." caption above the ladder. */
      var ln = this.ladLine(), lows = L.breaks.map(function (b, i) { return Object.keys(ln).reduce(function (m, k) { return Math.min(m, ln[k][i]); }, Infinity); });
      var track = box.querySelector('[data-pk-ladder-track]');
      if (!this._ladBuilt) {
        this._ladBuilt = true;
        track.insertAdjacentHTML('beforeend', L.labels.map(function (lab, i) {
          return '<div class="pk-ladder__node' + (i === top ? ' is-best' : '') + '" data-pk-node="' + i + '"><span class="pk-ladder__lab">' + esc(lab) + '</span><span class="pk-ladder__dot" aria-hidden="true"></span><span class="pk-ladder__pr"></span>' + '</div>';
        }).join(''));
      }
      track.querySelectorAll('[data-pk-node]').forEach(function (nd) {
        var i = +nd.dataset.pkNode;
        nd.classList.toggle('is-on', lad.n > 0 && i <= lad.ti);
        nd.classList.toggle('is-cur', lad.n > 0 && i === lad.ti);
        /* Owner, 28 Oct 2026: each tier shows its lowest price per piece across sizes ("from"), which matches the
           "as low as" line; each size card shows its own price. */
        nd.querySelector('.pk-ladder__pr').innerHTML = self.money(self.ladCents(fr[i])) + '<small>/ea</small>';
      });
      box.querySelector('[data-pk-ladder-fill]').style.width = (lad.n ? lad.ti / top * 75 : 0) + '%';
      var foot = this.cartPieces ? 'Includes ' + this.cartPieces + ' piece' + (this.cartPieces === 1 ? '' : 's') + ' already in your cart' : '';
      var footEl = box.querySelector('[data-pk-ladder-foot]');
      footEl.textContent = foot;
      footEl.hidden = !foot;
      if (this.g1) {
        /* Owner, 30 Oct 2026 (Design 1): one line under the dots, with the shopper's own price. */
        var mEl = box.querySelector('[data-pk-ladder-msg]');
        if (!mEl) { footEl.insertAdjacentHTML('beforebegin', '<p class="pk-ladder__msg" data-pk-ladder-msg aria-live="polite"></p>'); mEl = box.querySelector('[data-pk-ladder-msg]'); }
        var each = function (c) { return self.money(self.ladCents(c)) + '<small>/ea</small>'; };
        /* Owner, 31 Oct 2026: no "Buy more. Save more." heading on the piece-price table above Add To Cart. */
        var badge = box.querySelector('[data-pk-ladder-badge]'), lit = lad.n > 0 && lad.ti > 0;
        if (badge) {
          if (lit && !badge.classList.contains('is-lit') && this._ladTi !== undefined) { badge.classList.remove('is-pop'); void badge.offsetWidth; badge.classList.add('is-pop'); }
          badge.classList.toggle('is-lit', lit);
        }
        var sEl = box.querySelector('[data-pk-ladder-save]');
        if (!sEl) { mEl.insertAdjacentHTML('beforebegin', '<p class="pk-ladder__save" data-pk-ladder-save aria-live="polite" hidden><span data-pk-save-amt hidden></span><span class="pk-ladder__ship" data-pk-ladder-ship hidden></span></p>'); sEl = box.querySelector('[data-pk-ladder-save]'); }
        /* Saving on the covers picked so far (against the 1-piece price), and what the next tier adds to it. */
        var cur = 0, base = 0, more = 0;
        (this.lines() || []).forEach(function (l) {
          var lr = l.variant && l.variant.available && self.ladRow(l.piece, l.size);
          if (!lr) return;
          cur += self.ladCents(lr[lad.ti]) * l.qty; base += self.ladCents(lr[0]) * l.qty;
          if (lad.ti < top) more += (self.ladCents(lr[lad.ti]) - self.ladCents(lr[lad.ti + 1])) * l.qty;
        });
        /* Owner, 30 Oct 2026: the saving counts up in the one line below (round 39). */
        /* Owner, 30 Oct 2026: say when the order reaches free shipping (covers picked here plus the cart). */
        var fsAt = +((document.querySelector('[data-pk-free-ship]') || {}).dataset || {}).pkFreeShip || 0;
        var fsOn = !!(fsAt && lad.n && cur + (this.cartTotal || 0) >= fsAt), shipEl = sEl.querySelector('[data-pk-ladder-ship]');
        if (shipEl) {
          shipEl.textContent = base - cur > 0 ? ' + free shipping' : 'Free shipping unlocked';
          if (fsOn && this._fsOn === false) { shipEl.classList.remove('is-pop'); void shipEl.offsetWidth; shipEl.classList.add('is-pop'); }
          shipEl.hidden = !fsOn;
          this._fsOn = fsOn;
          sEl.hidden = !(base - cur > 0) && !fsOn;
        }
        sEl.hidden = true;
        /* Owner, 30 Oct 2026 ("still leave this but in one line"): the saving so far in green, then the next tier, so
           every cover added moves the line. */
        if (!mEl.querySelector('[data-pk-one-next]')) mEl.innerHTML = '<b class="pk-ladder__sv" hidden></b><span class="pk-ladder__dotsep" hidden> · </span><span data-pk-one-next></span>';
        var svEl = mEl.querySelector('.pk-ladder__sv'), nxEl = mEl.querySelector('[data-pk-one-next]'), saved = base - cur, nAdd = lad.ti < top ? L.breaks[lad.ti + 1] - lad.n : 0;
        this.ladSave(svEl, saved);
        nxEl.innerHTML = !lad.n ? '' : lad.ti === top ? '<b>Best price unlocked</b>'
          : more > 0 ? '<b>Add ' + nAdd + ' more</b>' + (saved > 0 ? ', save ' + this.money(more) + ' more' : ' and save ' + this.money(more))
          : '<b>Add ' + nAdd + ' more</b> for a lower price';
        mEl.querySelector('.pk-ladder__dotsep').hidden = !(saved > 0 && nxEl.innerHTML);
        mEl.hidden = !lad.n;
        /* Owner, 30 Oct 2026 (option 2): the mix-and-match line sits under the Select covers heading. */
        var grpM = box.nextElementSibling, labM = grpM && grpM.classList.contains('pk-pick__group') && grpM.querySelector('.pk-pick__label');
        if (labM && !grpM.querySelector('.pk-pick__mix')) labM.insertAdjacentHTML('afterend', '<p class="pk-pick__mix">Mix and match seat, back and chaise covers.</p>');
        var prevTi = this._ladTi === undefined ? lad.ti : this._ladTi;
        if (lad.n && lad.ti > prevTi) {
          var pn = track.querySelector('[data-pk-node="' + lad.ti + '"]');
          if (pn) { pn.classList.remove('is-pop'); void pn.offsetWidth; pn.classList.add('is-pop'); setTimeout(function () { pn.classList.remove('is-pop'); }, 700); }
          if (lad.ti === top && !this._confetti) { this._confetti = true; this.ladConfetti(box); }
        }
        this._ladTi = lad.n ? lad.ti : -1;
      }
      if (!nudge) return;
      nudge.classList.toggle('is-done', lad.ti === top);
      /* Owner, 29 Oct 2026: short line, "Add 1 more → $27.99 each", priced from the shopper's own pieces. */
      var nx = lad.ti === top ? top : lad.n ? lad.ti + 1 : 1;
      var np = '<strong>' + this.money(this.ladCents(fr[nx])) + '</strong> each';
      /* Owner, 29 Oct 2026: centred, with the action words in bold. */
      if (lad.ti === top) nudge.innerHTML = '<b>Best price unlocked:</b> ' + np;
      else {
        var need = L.breaks[nx] - lad.n;
        nudge.innerHTML = '<b>Add ' + need + (lad.n ? ' more' : ' piece' + (need === 1 ? '' : 's')) + '</b> → ' + np;
      }
    }
    /* Design 1 (owner, 30 Oct 2026): a cushion drawn to scale against the largest size, with a measuring line. */
    g1SizeArt(p, z, rp, sizes, hex) {
      var key = p === 'chaise' ? 'W' : 'L';
      if (!rp || !rp[z] || !rp[z][key]) return '';
      var max = 0;
      sizes.forEach(function (zz) { var r = rp[zz] && rp[zz][key]; if (r && r[1] > max) max = r[1]; });
      if (!max) return '';
      var base = '#524F47'; /* Owner, 30 Oct 2026: the tile icons' highlight colour, so both pictures match. */
      var shade = function (f) {
        var n = parseInt(base.slice(1), 16), c = [n >> 16, (n >> 8) & 255, n & 255].map(function (v) { return Math.max(0, Math.min(255, Math.round(f > 0 ? v + (255 - v) * f : v * (1 + f)))); });
        return 'rgb(' + c.join(',') + ')';
      };
      if (p === 'back') return this.g1BackArt(z, rp, max, shade);
      if (p === 'chaise') return this.g1ChaiseArt(z, rp, sizes, shade);
      var r = rp[z][key], len = 142 * r[1] / max;
      /* Seat: flat cushion. Back: standing, taller face, shallow top. Chaise: flat, deeper. */
      var T = p === 'back' ? 44 : 30, dx = -32, dy = p === 'back' ? 11 : p === 'chaise' ? 26 : 22, b = 2.5; /* turned to the right */
      var x0 = (200 - len - dx) / 2, y2 = 18 + dy + T, y1 = y2 - T, mid = (y1 + y2) / 2, xr = x0 + len;
      var f = function (v) { return Math.round(v * 10) / 10; };
      var top = 'M' + f(x0) + ' ' + f(y1) + 'Q' + f(x0 + len / 2) + ' ' + f(y1 - b) + ' ' + f(xr) + ' ' + f(y1) + 'L' + f(xr + dx) + ' ' + f(y1 - dy) + 'Q' + f(x0 + len / 2 + dx) + ' ' + f(y1 - dy - b) + ' ' + f(x0 + dx) + ' ' + f(y1 - dy) + 'Z';
      var front = 'M' + f(x0) + ' ' + f(y1) + 'Q' + f(x0 + len / 2) + ' ' + f(y1 - b) + ' ' + f(xr) + ' ' + f(y1) + 'Q' + f(xr + b) + ' ' + f(mid) + ' ' + f(xr) + ' ' + f(y2) + 'Q' + f(x0 + len / 2) + ' ' + f(y2 + b) + ' ' + f(x0) + ' ' + f(y2) + 'Q' + f(x0 - b) + ' ' + f(mid) + ' ' + f(x0) + ' ' + f(y1) + 'Z';
      var side = 'M' + f(x0) + ' ' + f(y1) + 'L' + f(x0 + dx) + ' ' + f(y1 - dy) + 'Q' + f(x0 + dx - b) + ' ' + f(mid - dy) + ' ' + f(x0 + dx) + ' ' + f(y2 - dy) + 'L' + f(x0) + ' ' + f(y2) + 'Q' + f(x0 - b) + ' ' + f(mid) + ' ' + f(x0) + ' ' + f(y1) + 'Z';
      var ay = y2 + 14, lab = Math.round(r[0]) + '–' + Math.round(r[1]) + '″';
      return '<svg class="pk-sa" viewBox="0 0 200 ' + f(ay + 20) + '" role="img" aria-label="' + (SIZE_NAMES[z] || z) + ', ' + lab + (key === 'W' ? ' wide' : ' long') + '">' +
        '<g stroke="#524F47" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="' + side + '" fill="' + shade(-0.22) + '"/><path d="' + front + '" fill="' + base + '"/><path d="' + top + '" fill="' + shade(0.18) + '"/></g>' +
        '<path d="M' + f(x0 + 5) + ' ' + f(y1 + 4) + 'L' + f(xr - 5) + ' ' + f(y1 + 4) + '" stroke="#ffffff" stroke-width="1.4" fill="none" opacity=".35"/>' +
        '<path class="pk-sa__dim" d="M' + f(x0) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(xr) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(x0) + ' ' + f(ay) + 'H' + f(xr) + '"/>' +
        '<text class="pk-sa__lab" x="' + f(x0 + len / 2) + '" y="' + f(ay + 15) + '" text-anchor="middle">' + lab + '</text>' +
        '</svg>';
    }
    /* Back cover: an upright cushion, standing straight, with piping, at its real length. */
    g1BackArt(z, rp, max, shade) {
      var f = function (v) { return Math.round(v * 10) / 10; };
      var r = rp[z].L, w = rp[z].W, k = 142 / max, len = r[1] * k, H = Math.min(64, (w ? w[1] : 21.7) * k), t = 0, dx = -12, dy = 8, b = 2.5; /* turned to the right */
      var x0 = (200 - len - t - dx) / 2, xr = x0 + len, y2 = 14 + dy + H, y1 = y2 - H, mid = (y1 + y2) / 2;
      var front = 'M' + f(x0) + ' ' + f(y2) + 'Q' + f(x0 + len / 2) + ' ' + f(y2 + b) + ' ' + f(xr) + ' ' + f(y2) + 'Q' + f(xr + t / 2 + b) + ' ' + f(mid) + ' ' + f(xr + t) + ' ' + f(y1) +
        'Q' + f(x0 + t + len / 2) + ' ' + f(y1 - b) + ' ' + f(x0 + t) + ' ' + f(y1) + 'Q' + f(x0 + t / 2 - b) + ' ' + f(mid) + ' ' + f(x0) + ' ' + f(y2) + 'Z';
      var side = 'M' + f(x0) + ' ' + f(y2) + 'L' + f(x0 + dx) + ' ' + f(y2 - dy) + 'L' + f(x0 + t + dx) + ' ' + f(y1 - dy) + 'L' + f(x0 + t) + ' ' + f(y1) + 'Q' + f(x0 + t / 2 - b) + ' ' + f(mid) + ' ' + f(x0) + ' ' + f(y2) + 'Z';
      var top = 'M' + f(x0 + t) + ' ' + f(y1) + 'Q' + f(x0 + t + len / 2) + ' ' + f(y1 - b) + ' ' + f(xr + t) + ' ' + f(y1) + 'L' + f(xr + t + dx) + ' ' + f(y1 - dy) + 'L' + f(x0 + t + dx) + ' ' + f(y1 - dy) + 'Z';
      var i = 6, pipe = 'M' + f(x0 + i) + ' ' + f(y2 - i) + 'L' + f(xr - i) + ' ' + f(y2 - i) + 'L' + f(xr + t - i) + ' ' + f(y1 + i) + 'L' + f(x0 + t + i) + ' ' + f(y1 + i) + 'Z';
      var ay = y2 + 14, lab = Math.round(r[0]) + '–' + Math.round(r[1]) + '″';
      return '<svg class="pk-sa" viewBox="0 0 200 ' + f(ay + 20) + '" role="img" aria-label="' + (SIZE_NAMES[z] || z) + ', ' + lab + ' long">' +
        '<g stroke="#524F47" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="' + top + '" fill="' + shade(0.18) + '"/><path d="' + side + '" fill="' + shade(-0.22) + '"/><path d="' + front + '" fill="#524F47"/></g>' +
        '<path d="' + pipe + '" stroke="#ffffff" stroke-width="1.4" fill="none" opacity=".3" stroke-linejoin="round"/>' +
        '<path class="pk-sa__dim" d="M' + f(x0) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(xr) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(x0) + ' ' + f(ay) + 'H' + f(xr) + '"/>' +
        '<text class="pk-sa__lab" x="' + f(x0 + len / 2) + '" y="' + f(ay + 15) + '" text-anchor="middle">' + lab + '</text></svg>';
    }
    /* Chaise cover: an L-shaped cushion (the long chaise seat plus the corner it meets). Only the chaise part's width
       changes between sizes, so the arrow measures that edge. */
    g1ChaiseArt(z, rp, sizes, shade) {
      /* Owner, 30 Oct 2026 (sketch): the L from the front. The chaise is the tall part on the right running back,
         the seat part is the foot along the front on the left. Seen from slightly above and left, so the front and
         left edges show their thickness. Only the chaise part's width changes between sizes; the arrow measures it. */
      var f = function (v) { return Math.round(v * 10) / 10; };
      var wmax = 0;
      sizes.forEach(function (zz) { var w = rp[zz] && rp[zz].W; if (w && w[1] > wmax) wmax = w[1]; });
      var w = rp[z].W, Lr = rp[z].L, Wc = w[1], E = 34, Dp = Lr ? Lr[1] : 75, z1 = Dp * 0.4, T = 12;
      var sx = -0.1, sy = 0.42, k = 150 / (wmax + E + Dp * 0.1);
      var span = (Wc + E) * k + Dp * k * 0.1, ox = (200 - span) / 2 + Dp * k * 0.1, oy = 36 + Dp * k * sy + T;
      var X = function (x, d) { return ox + x * k + d * k * sx; }, Y = function (d, h) { return oy - d * k * sy - h; };
      var P = function (x, d, h) { return f(X(x, d)) + ' ' + f(Y(d, h)); };
      var face = function (a, b2) { return 'M' + P(a[0], a[1], 0) + 'L' + P(b2[0], b2[1], 0) + 'L' + P(b2[0], b2[1], T) + 'L' + P(a[0], a[1], T) + 'Z'; };
      var W2 = Wc + E;
      var top = 'M' + P(0, 0, T) + 'L' + P(W2, 0, T) + 'L' + P(W2, Dp, T) + 'L' + P(E, Dp, T) + 'L' + P(E, z1, T) + 'L' + P(0, z1, T) + 'Z';
      var side = shade(-0.22), fr = '#524F47';
      var g = '<path d="' + face([E, Dp], [E, z1]) + '" fill="' + side + '"/>' + '<path d="' + face([0, z1], [0, 0]) + '" fill="' + side + '"/>' +
        '<path d="' + face([0, 0], [W2, 0]) + '" fill="' + fr + '"/>' + '<path d="' + top + '" fill="' + shade(0.18) + '"/>';
      /* Owner, 30 Oct 2026 (sketch): the ruler runs under the whole front edge, corner to corner, with the inches below. */
      var ax0 = X(0, 0), ax1 = X(W2, 0), ay = oy + 10, lab = Math.round(w[0]) + '–' + Math.round(w[1]) + '″';
      return '<svg class="pk-sa" viewBox="0 0 200 ' + f(ay + 20) + '" role="img" aria-label="' + (SIZE_NAMES[z] || z) + ', ' + lab + ' wide">' +
        '<g stroke="#524F47" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round">' + g + '</g>' +
        '<path class="pk-sa__dim" d="M' + f(ax0) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(ax1) + ' ' + f(ay - 4) + 'V' + f(ay + 4) + 'M' + f(ax0) + ' ' + f(ay) + 'H' + f(ax1) + '"/>' +
        '<text class="pk-sa__lab" x="' + f((ax0 + ax1) / 2) + '" y="' + f(ay + 15) + '" text-anchor="middle">' + lab + '</text></svg>';
    }
    /* Design 1 (owner, 30 Oct 2026): "You're saving $X" counts up to the new amount. */
    ladSave(el, cents) {
      var self = this, from = this._saveShown || 0;
      this._saveShown = cents > 0 ? cents : 0;
      if (this._saveRaf) cancelAnimationFrame(this._saveRaf);
      var amt = el.querySelector('[data-pk-save-amt]') || el;
      if (cents <= 0) { el.hidden = true; amt.hidden = true; amt.textContent = ''; return; }
      el.hidden = false; amt.hidden = false;
      var put = function (c) { amt.textContent = 'You\'re saving ' + self.money(Math.round(c)); };
      if (from === cents || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) { put(cents); return; }
      var t0 = null, step = function (t) { if (t0 === null) t0 = t; var k = Math.min(1, (t - t0) / 450); put(from + (cents - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) self._saveRaf = requestAnimationFrame(step); };
      put(from);
      this._saveRaf = requestAnimationFrame(step);
      /* Background tabs pause animation frames: land on the final amount regardless. */
      setTimeout(function () { if (self._saveShown === cents) { cancelAnimationFrame(self._saveRaf); put(cents); } }, 520);
    }
    /* One short confetti burst the first time the 6+ tier is reached on this page. */
    ladConfetti(box) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cols = ['#FBE495', '#111111', '#b3261e', '#2E7D4F', '#dccfbd'], html = '';
      for (var i = 0; i < 28; i++) {
        var x = Math.round((Math.random() - .5) * 320), y = Math.round(-40 - Math.random() * 90), r = Math.round(Math.random() * 540);
        html += '<i style="left:' + (70 + Math.random() * 25) + '%;background:' + cols[i % cols.length] + ';--x:' + x + 'px;--y:' + y + 'px;--r:' + r + 'deg;animation-delay:' + Math.round(Math.random() * 120) + 'ms"></i>';
      }
      var c = document.createElement('div');
      c.className = 'pk-confetti'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = html;
      box.appendChild(c);
      setTimeout(function () { c.remove(); }, 1600);
    }
    money(c) { if (this.mf) return pkMoneyOut(c, this.mf, false); return (Math.round(c) % 100 === 0 ? this.fmt0 : this.fmt).format(c / 100); }
    /* Round 132: the Spend and Save bar (assets/pdp-ss-bar.js) follows the selection on this page. */
    ssEmit(sel) {
      var art = this.closest('.pk');
      if (!art) return;
      art._pkSel = sel;
      art.dispatchEvent(new CustomEvent('pk:selection', { detail: sel }));
    }
    ssHints() {
      if (this.single) return [];
      var c = this.state.colour, out = [];
      [['Back Cover', 'one back cover'], ['Seat Cover', 'one seat cover']].forEach(function (k) {
        var best = null;
        this.fabric.variants.forEach(function (v) { if (v.available && v.colour === c && String(v.size || '').indexOf(k[0]) === 0 && (!best || v.price < best.price)) best = v; });
        if (best) out.push({ text: k[1], price: best.price });
      }, this);
      return out;
    }
    /* Round 129: a crossed-out price shows cents when the price next to it has cents. */
    wasMoney(was, now) { if (this.mf) return pkMoneyOut(was, this.mf, Math.round(now) % 100 !== 0); return (Math.round(was) % 100 === 0 && Math.round(now) % 100 === 0 ? this.fmt0 : this.fmt).format(was / 100); }
    index() {
      if (this.single) return this.indexSingle();
      var idx = {}, sizes = { seat: [], back: [], chaise: [] };
      this.fabric.variants.forEach(function (v) {
        var m = /^(\w+).*\((\w+)\)/.exec(v.size || '');
        if (!m) return;
        var piece = m[1].toLowerCase(), size = m[2].toUpperCase();
        idx[piece + '|' + size + '|' + v.colour] = v;
        if (sizes[piece] && sizes[piece].indexOf(size) === -1) sizes[piece].push(size);
      });
      ['seat', 'back', 'chaise'].forEach(function (p) {
        sizes[p].sort(function (a, b) { return 'SML'.indexOf(a) - 'SML'.indexOf(b); });
      });
      this.vIndex = idx;
      this.sizes = sizes;
      var self = this;
      ['seat', 'back', 'chaise'].forEach(function (p) {
        if (self.sizes[p].length && self.sizes[p].indexOf(self.state[p].size) === -1) self.state[p].size = self.sizes[p][0];
      });
      if (!this.fabric.colours.some(function (c) { return c.name === self.state.colour; })) {
        var firstAvail = this.fabric.colours.find(function (c) { return self.colourAvailable(c.name); });
        this.state.colour = (firstAvail || this.fabric.colours[0]).name;
      }
    }
    variant(piece, size, colour) { return this.vIndex[piece + '|' + size + '|' + colour] || null; }
    /* QA 17 Oct (H1): open on a selection that can be bought. Covers only, and only on load or a fabric
       switch, never after the shopper picks something (a sold-out pick must still reach Notify Me).
       1. The pre-filled sizes in the preferred colours (k_colour_order), then the other colours in order.
       2. If no colour has those sizes, the nearest sizes in stock (bigger first on a tie), same colour order.
       Colour moves before size because a wrong size does not fit, while the colour is easy to see and change. */
    /* Owner, 30 Oct 2026 ("for sold out items to show the notify if available"): a page that opens on a colour with a
       cover type sold out in every size (Wheat in Ivory Beige) opens on the first colour with every cover type in stock.
       Page open only: a ?variant= link, a fabric switch (Round 125) and a colour the shopper picks are never moved. */
    openInStock() {
      if (this.single || this.D.startVariant || !this.sizes) return;
      var self = this, types = ['seat', 'back', 'chaise'].filter(function (p) { return (self.sizes[p] || []).length; });
      if (!types.length) return;
      var ok = function (c) { return types.every(function (p) { return self.sizes[p].some(function (z) { var v = self.variant(p, z, c); return !!(v && v.available); }); }); };
      if (ok(this.state.colour)) return;
      var c = this.fabric.colours.find(function (x) { return ok(x.name); });
      if (c) this.state.colour = c.name;
    }
    pickInStock() {
      if (this.single) return;
      var self = this, st = this.state;
      var pieces = ['seat', 'back', 'chaise'].filter(function (p) { return st[p].qty > 0 && self.sizes[p].length; });
      if (!pieces.length) return;
      var want = {};
      pieces.forEach(function (p) { want[p] = st[p].size; });
      var inStock = function (p, size, colour) { var v = self.variant(p, size, colour); return !!(v && v.available); };
      var fits = function (colour, sizes) { return pieces.every(function (p) { return inStock(p, sizes[p], colour); }); };
      if (fits(st.colour, want)) return;
      var names = this.fabric.colours.map(function (c) { return c.name; });
      /* Round 125 (owner, 20 Oct 2026: "When selected smore it automatically changed to the last colour should be the first colour"):
         the colour is never moved to find stock. Only the sizes move, within the shown colour; if nothing fits, the sold-out
         note and Notify Me show for that colour. */
      var order = [st.colour].filter(function (n) { return names.indexOf(n) !== -1; });
      var c1 = order.find(function (c) { return fits(c, want); });
      if (c1) { st.colour = c1; return; }
      var near = function (p, colour) {
        var w = 'SML'.indexOf(want[p]);
        var list = self.sizes[p].slice().sort(function (a, b) {
          var da = Math.abs('SML'.indexOf(a) - w), db = Math.abs('SML'.indexOf(b) - w);
          return da - db || 'SML'.indexOf(b) - 'SML'.indexOf(a);
        });
        return list.find(function (s) { return inStock(p, s, colour); }) || null;
      };
      for (var i = 0; i < order.length; i++) {
        var got = {}, all = pieces.every(function (p) { var s = near(p, order[i]); got[p] = s; return !!s; });
        if (all) {
          st.colour = order[i];
          /* Round 124 (QA 20 Oct): remember sizes picked for the shopper, so the row can say so. */
          self._autoSize = {};
          pieces.forEach(function (p) { if (got[p] !== want[p]) self._autoSize[p] = { from: want[p], to: got[p], colour: order[i] }; st[p].size = got[p]; });
          return;
        }
      }
    }
    /* Round 174 (phone QA, 24 Oct 2026): pickInStock only moves rows that already have covers in them, so a row at 0 kept
       the template size (M) even when M was sold out in the shown colour. The page then opened on a sold-out size
       (Magic Wheat seat and chaise, Checkered seat, S'more Earl Grey). For rows at 0 that the shopper has not set a size on,
       show the template size when it is in stock in this colour, otherwise the nearest size in stock (bigger first on a tie).
       Runs on load, on a fabric switch and on a colour change. A size the shopper taps is never moved (Notify Me still works). */
    idleSizes() {
      if (this.single) return;
      var self = this, st = this.state;
      ['seat', 'back', 'chaise'].forEach(function (p) {
        var sizes = self.sizes[p];
        if (!sizes.length || st[p].qty > 0 || self._userSize[p]) return;
        var want = sizes.indexOf(self._baseSize[p]) !== -1 ? self._baseSize[p] : sizes[0];
        var ok = function (s) { var v = self.variant(p, s, st.colour); return !!(v && v.available); };
        var w = 'SML'.indexOf(want);
        var pick = ok(want) ? want : sizes.slice().sort(function (a, b) {
          var da = Math.abs('SML'.indexOf(a) - w), db = Math.abs('SML'.indexOf(b) - w);
          return da - db || 'SML'.indexOf(b) - 'SML'.indexOf(a);
        }).find(ok);
        st[p].size = pick || want;
      });
    }
    /* What stops add to cart right now, for the sticky bar: its label, a sentence, and where to scroll. */
    missingInfo() {
      var ls = this.lines();
      var grp = function (el) { return el ? el.closest('.pk-pick__group') || el : null; };
      if (this.duo && ls.some(function (l) { return l.incomplete; })) return { label: 'Select Color & Size', text: 'Pick a color and size for each ' + String(this.D.itemName || 'item').toLowerCase() + '.', el: grp(this.querySelector('[data-pk-packs]')) };
      if (!ls.length) {
        if (this.single) return { label: 'Choose A Size', text: 'Choose a size.', el: grp(this.querySelector('[data-pk-sizecards]')) };
        /* Owner, 29 Oct 2026 (Javvy): the empty piece-pricing button reads "Select at least 1 cover". */
        return { label: this.L ? 'Select At Least 1 Cover' : 'Add Your Covers', text: 'Add at least one cover.', el: this.querySelector('.pk-pick__rows') || grp(this.querySelector('[data-pk-colours]')) };
      }
      if (ls.some(function (l) { return !l.variant || !l.variant.available; })) {
        var issue = this.querySelector('[data-pk-issue]');
        return { label: 'Change Color Or Size', text: (issue && issue.textContent) || 'Sold out. Pick another colour or size.', el: grp(this.querySelector('[data-pk-colours]')) };
      }
      return null;
    }
    /* One item per variant (mats): sizes in product order, "Seat Mat - 2 Seater Regular (25.6x47.2 in)". */
    indexSingle() {
      var self = this, idx = {}, list = [];
      this.fabric.variants.forEach(function (v) {
        idx[v.size + '|' + v.colour] = v;
        if (list.indexOf(v.size) === -1) list.push(v.size);
      });
      this.vIndex = idx;
      this.sizeList = list;
      /* Round 127: a ?variant= link (Google Shopping, ads) opens on that variant's size, sold out or not. */
      var sv = this.D.startVariant && !this._startUsed ? this.fabric.variants.find(function (v) { return v.id === self.D.startVariant; }) : null;
      if (sv) { this._startUsed = true; this.state.colour = sv.colour; this.state.size = sv.size; }
      if (!this.fabric.colours.some(function (c) { return c.name === self.state.colour; })) {
        var firstAvail = this.fabric.colours.find(function (c) { return self.colourAvailable(c.name); });
        this.state.colour = (firstAvail || this.fabric.colours[0]).name;
      }
      if (list.indexOf(this.state.size) === -1) {
        var want = String(this.D.singleDefault || '').toLowerCase();
        /* Round 171: "cheapest" opens on the lowest-priced size in stock in this colour (ties keep size order). */
        var pick = want === 'cheapest' ? list.reduce(function (m, sz) { var v = idx[sz + '|' + self.state.colour]; return v && v.available && (!m || v.price < idx[m + '|' + self.state.colour].price) ? sz : m; }, null)
          : want ? list.find(function (sz) { var v = idx[sz + '|' + self.state.colour]; return sz.toLowerCase().indexOf(want) !== -1 && v && v.available; }) : null;
        pick = pick || list.find(function (sz) { var v = idx[sz + '|' + self.state.colour]; return v && v.available; }) || list[0];
        this.state.size = pick || '';
      }
    }
    sizeParts(sz) {
      var name = String(sz).split(' - ').pop().split('(')[0].trim();
      var m = /\(([\d.]+)\s*x\s*([\d.]+)\s*in\)/i.exec(sz);
      return { name: name || sz, dims: m ? m[1] + ' × ' + m[2] + ' in' : '' };
    }
    /* Duo offer (Round 33): Qomfort's picker behaviour in Nolan's design. Duo card left, Single right; one
       box per item with its own colour and size; nothing pre-chosen; add-to-cart waits until every shown
       box is complete. The discount itself is the store's automatic one (Round 30 notes). */
    /* Round 170 (23 Oct 2026): the pack is a set price per size, not a % off. The store runs one "buy 1, get 1 $X off"
       discount per $ amount; D.duoOffs maps each variant id to [$X, US price]. Round 171 (27 Oct 2026): with 2+ items each one
       gets half its own $X off, so two different sizes get half of each $X, as at checkout. Other currencies scale $X by the item's local price. */
    setPricing() { return !!this.D.duoOffs && !this.D.duoFree; }
    packOff(v) { var e = this.D.duoOffs && v && this.D.duoOffs[v.id]; return e ? Math.round(e[0] / e[1] * v.price) : 0; }
    pairOff(a, b) { var o = this.D.duoOffs; if (!o || !a || !b) return 0; var ea = o[a.id], eb = o[b.id]; return ea && eb ? Math.round((this.packOff(a) + this.packOff(b)) / 2) : 0; }
    /* Per item in a 2-pack of one size: half the $X (the card shows the set price split over 2). */
    duoOff(price, v) { if (!(this.duo && !this.D.duoFree && this.state.pack === 2)) return 0; return this.setPricing() ? Math.round(this.packOff(v) / 2) : Math.round(price * this.D.duoPct / 100); }
    /* Buy 1, get 1 free (duoFree): the store's deal makes the cheaper of the two items free. */
    duoFreeOff(prices) { return this.duo && this.D.duoFree && this.state.pack === 2 && prices.length === 2 ? Math.min(prices[0], prices[1]) : 0; }
    duoBase() {
      var best = null;
      this.fabric.variants.forEach(function (v) { if (v.available && (!best || v.price < best.price)) best = v; });
      return best || this.fabric.variants[0];
    }
    itemVariant(it) { return it && it.colour && it.size ? this.vIndex[it.size + '|' + it.colour] || null : null; }
    sizeVariant(sz, colour) {
      if (colour) return this.vIndex[sz + '|' + colour] || null;
      var self = this, any = null;
      this.fabric.colours.forEach(function (c) { var v = self.vIndex[sz + '|' + c.name]; if (v && (!any || (v.available && !any.available))) any = v; });
      return any;
    }
    pinItem(i) { if (!this._pin) this._pin = [false, false]; this._pin[i] = true; }
    size2() { var it = this.state.items[1]; return (it && it.size) || this.state.size; }
    renderDuo() {
      /* Round 40: Kokoon's flow. Colour and size come from the shared pickers above; the pack rows sit below. */
      var self = this, st = this.state, D = this.D;
      [this.querySelector('[data-pk-colours]'), this.querySelector('[data-pk-sizecards]')].forEach(function (el) { var g = el && el.closest('.pk-pick__group'); if (g) g.hidden = false; });
      /* Round 46: size is picked inside the offer rows, so the Size section is hidden. */
      var sizeGrp = this.querySelector('[data-pk-sizecards]');
      sizeGrp = sizeGrp && sizeGrp.closest('.pk-pick__group');
      if (sizeGrp) sizeGrp.hidden = true;
      var tabs = this.querySelector('[data-pk-items]');
      if (tabs) tabs.hidden = true;
      if (this.boxes) { this.boxes.remove(); this.boxes = null; }
      var box = this.querySelector('[data-pk-packs]');
      if (!box) return;
      if (!this._packsMoved) {
        this._packsMoved = true;
        var grp = box.closest('.pk-pick__group');
        var sizeG = this.querySelector('[data-pk-sizecards]');
        sizeG = sizeG && sizeG.closest('.pk-pick__group');
        if (grp && sizeG) { grp.classList.add('pk-pick__group--packs'); sizeG.parentNode.insertBefore(grp, sizeG.nextSibling); }
        this.addEventListener('keydown', function (e) {
          var r = e.target.closest && e.target.closest('[data-pk-pack]');
          if (r && e.target === r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); r.click(); }
        });
      }
      /* Round 46: each item keeps a colour and size in stock. Item 1 is the colour swatches above plus
         state.size; item 2 has its own. After a colour change the size moves, after a size change the colour. */
      var avail = function (sz, c) { var v = self.vIndex[sz + '|' + c]; return !!(v && v.available); };
      var pins = this._pin || [false, false];
      var fix = function (it, keep, pinned) {
        if (avail(it.size, it.colour)) return;
        /* Round 65: a sold-out combination the shopper picked stays, so they can sign up to be notified. */
        if (pinned && self.vIndex[it.size + '|' + it.colour]) return;
        if (keep === 'size') { var c = self.fabric.colours.find(function (x) { return avail(it.size, x.name); }); if (c) { it.colour = c.name; return; } }
        var s = self.sizeList.find(function (x) { return avail(x, it.colour); });
        if (s) { it.size = s; return; }
        var c2 = self.fabric.colours.find(function (x) { return avail(it.size, x.name); });
        if (c2) it.colour = c2.name;
      };
      var one = { colour: st.colour, size: st.size };
      fix(one, this._keep0 || 'colour', pins[0]);
      if (one.colour !== st.colour) { st.colour = one.colour; this.renderColours(); }
      st.size = one.size;
      st.items[0].colour = st.colour;
      /* Round 122: until the shopper picks #2's colour, #2 follows #1. */
      if (!pins[1]) st.items[1].colour = st.colour;
      var two = { colour: st.items[1].colour, size: this.size2() };
      fix(two, this._keep1 || 'size', pins[1]);
      st.items[1].colour = two.colour;
      if (two.size !== this.size2()) st.items[1].size = two.size;
      this._keep0 = this._keep1 = null;
      var vFor = function (c) { return self.vIndex[st.size + '|' + c] || null; };
      var sz2 = this.size2();
      var v2For = function (c) { return self.vIndex[sz2 + '|' + c] || null; };
      var base = vFor(st.items[0].colour) || this.duoBase();
      var v2 = v2For(st.items[1].colour);
      var pair = [base, v2 && v2.available ? v2 : base];
      var pairNow = D.duoFree ? Math.max(pair[0].price, pair[1].price) : this.setPricing() ? pair[0].price + pair[1].price - this.pairOff(pair[0], pair[1]) : pair.reduce(function (t, x) { return t + x.price - Math.round(x.price * D.duoPct / 100); }, 0);
      var pairWas = pair.reduce(function (t, x) { return t + Math.max(x.compare, x.price); }, 0);
      /* Owner, 29 Oct 2026: blankets and mats use the sofa-cover price line: "as low as" the 2-pack price per item for
         the chosen colour and size, with the single item's compare-at price per item crossed out. */
      var pel = this.article.querySelector('[data-pk-price]');
      if (pel) {
        var eachNow = Math.round(pairNow / 2), eachWas = Math.max(base.compare, base.price);
        pel.innerHTML = '<span class="pk-asl">as low as</span> <span class="pk-vh">Sale price: </span><span class="pk__now-live pk-red">' + this.money(eachNow) + '</span>' + (eachWas > eachNow ? ' <s class="pk__was-live"><span class="pk-vh">Compare at: </span>' + this.money(eachWas) + '/ea</s>' : '');
        /* Owner, 29 Oct 2026: the "save up to" pill shows on every product page, worked out from the 2-pack price. */
        var savePct = eachWas > eachNow ? Math.floor((1 - eachNow / eachWas) * 100) : 0;
        if (savePct >= 5) pel.innerHTML += ' <span class="pk-save">SAVE UP TO ' + savePct + '%</span>';
      }
      var cards = [
        { n: 1, title: '1 ' + D.itemName, callout: D.singleCallout, note: D.singleNote, now: base.price, was: Math.max(base.compare, base.price), badge: '' },
        /* Pack name (e.g. Couple Pack) as the 2-item title, with the item count underneath. */
        { n: 2, title: D.duoName ? D.duoName : '2 ' + D.itemPlural, sub: D.duoName ? '2\u00a0' + D.itemPlural : '', callout: D.duoCallout, note: '', now: pairNow, was: pairWas, badge: D.duoBadge }
      ];
      var chev = '<svg class="pk-sel__chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg>';
      /* Round 57: our own size dropdown (name and measurements, and the price per item in this row). */
      var unit = function (v) { var off = st.pack === 2 && !D.duoFree ? (self.setPricing() ? Math.round(self.packOff(v) / 2) : Math.round(v.price * D.duoPct / 100)) : 0; return { now: v.price - off, was: Math.max(v.compare, v.price) }; };
      var sizeDD = function (i, it, nm) {
        var cur = self.sizeParts(it.size), open = self._ddOpen === String(i);
        var opts = self.sizeList.map(function (sz) {
          var p = self.sizeParts(sz), any = self.fabric.colours.some(function (c) { return avail(sz, c.name); });
          var mine = avail(sz, it.colour), v = self.vIndex[sz + '|' + it.colour] || self.sizeVariant(sz, null), on = sz === it.size;
          var right = !any ? '<span class="pk-dd__out">Sold out</span>' : !mine ? '<span class="pk-dd__out">Other colours</span>' : (function () { var u = unit(v); return '<span class="pk-dd__now">' + self.money(u.now) + '</span>' + (u.was > u.now ? '<s class="pk-dd__was">' + self.wasMoney(u.was, u.now) + '</s>' : ''); })();
          return '<button type="button" role="option" aria-selected="' + on + '" class="pk-dd__opt' + (on ? ' is-on' : '') + (!any ? ' is-out' : '') + '" data-pk-iopt="' + esc(sz) + '" data-pk-i="' + i + '"><span class="pk-dd__txt"><span class="pk-dd__name">' + esc(p.name) + '</span>' + (p.dims ? '<span class="pk-dd__dims">' + esc(p.dims) + '</span>' : '') + '</span><span class="pk-dd__price">' + right + '</span></button>';
        }).join('');
        return '<div class="pk-dd' + (open ? ' is-open' : '') + '"><button type="button" class="pk-sel pk-dd__btn" aria-haspopup="listbox" aria-expanded="' + open + '" aria-label="' + nm + ' size: ' + esc(cur.name) + '" data-pk-ddbtn="' + i + '"><span class="pk-dd__val"><span class="pk-dd__name">' + esc(cur.name) + '</span>' + (cur.dims ? '<span class="pk-dd__dims">' + esc(cur.dims) + '</span>' : '') + '</span>' + chev + '</button>' +
          '<div class="pk-dd__list" role="listbox" aria-label="' + nm + ' size"' + (open ? '' : ' hidden') + '>' + opts + '</div></div>';
      };
      /* Round 106: the colour picker uses the same dropdown as sizes (owner, 18 Oct 2026). */
      var dot = function (c, cls) { return '<span class="' + cls + '"' + (c.hex ? ' style="background:' + esc(c.hex) + '"' : '') + '>' + (!c.hex && c.swatch ? '<img src="' + c.swatch + '" alt="" width="40" height="40">' : '') + '</span>'; };
      var colourDD = function (i, it, co, nm) {
        var key = 'c' + i, open = self._ddOpen === key;
        var opts = self.fabric.colours.map(function (c) {
          var out = !avail(it.size, c.name), on = c.name === it.colour;
          return '<button type="button" role="option" aria-selected="' + on + '" class="pk-dd__opt pk-dd__opt--colour' + (on ? ' is-on' : '') + (out ? ' is-out' : '') + '" data-pk-icopt="' + esc(c.name) + '" data-pk-i="' + i + '"><span class="pk-dd__txt pk-dd__txt--colour">' + dot(c, 'pk-dd__dot') + '<span class="pk-dd__name">' + esc(c.name) + '</span>' + (self.isNewColour(c.name) ? '<span class="pk-dd__new">' + esc(self.D.newText || 'New') + '</span>' : '') + '</span>' + (out ? '<span class="pk-dd__price"><span class="pk-dd__out">Sold out in this size</span></span>' : '') + '</button>';
        }).join('');
        return '<div class="pk-dd pk-dd--colour' + (open ? ' is-open' : '') + '"><button type="button" class="pk-sel pk-sel--colour pk-dd__btn" aria-haspopup="listbox" aria-expanded="' + open + '" aria-label="' + nm + ' colour: ' + esc(it.colour) + '" data-pk-ddbtn="' + key + '">' + dot(co, 'pk-sel__dot') + '<span class="pk-dd__val"><span class="pk-dd__name">' + esc(it.colour) + '</span></span>' + chev + '</button>' +
          '<div class="pk-dd__list" role="listbox" aria-label="' + nm + ' colour"' + (open ? '' : ' hidden') + '>' + opts + '</div></div>';
      };
      var itemSel = function (i, label) {
        var it = i === 0 ? { colour: st.colour, size: st.size } : { colour: st.items[1].colour, size: sz2 };
        var co = self.fabric.colours.find(function (c) { return c.name === it.colour; }) || {};
        var nm = esc(D.itemName) + (label ? ' ' + (i + 1) : '');
        var colOpts = self.fabric.colours.map(function (c) {
          var out = !avail(it.size, c.name);
          return '<option value="' + esc(c.name) + '"' + (c.name === it.colour ? ' selected' : '') + '>' + esc(c.name) + (out ? ' (sold out in this size)' : '') + '</option>';
        }).join('');
        var sizeOpts = self.sizeList.map(function (sz) {
          var any = self.fabric.colours.some(function (c) { return avail(sz, c.name); });
          return '<option value="' + esc(sz) + '"' + (sz === it.size ? ' selected' : '') + (any ? '' : ' disabled') + '>' + esc(self.sizeParts(sz).name) + (any ? (avail(sz, it.colour) ? '' : ' (other colours)') : ' (sold out)') + '</option>';
        }).join('');
        /* Round 110: one line per item, "#1 [colour] [size]" (owner, 18 Oct 2026). */
        return '<div class="pk-pack__item pk-pack__item--row">' + (label ? '<span class="pk-pack__num" aria-hidden="true">#' + (i + 1) + '</span>' : '') +
          '<div class="pk-pack__selects">' +
          colourDD(i, it, co, nm) +
          sizeDD(i, it, nm) +
          '</div></div>';
      };
      var selects = function (n) {
        /* Round 124 (QA 20 Oct): the Size guide button sits by the heading (the Size group above is hidden on these pages). */
        var sgb = self.querySelector('[data-pk-drawer-open^="pk-size-"]'), sgId = sgb && sgb.getAttribute('data-pk-drawer-open');
        var sgBtn = sgId && document.getElementById(sgId) ? '<button type="button" class="pk-link pk-pack__sg" data-pk-drawer-open="' + esc(sgId) + '">Size guide</button>' : '';
        return '<div class="pk-pack__more"><div class="pk-pack__more-top"><p class="pk-pack__more-label pk-pack__more-head">Color, Size</p>' + sgBtn + '</div>' + (n === 2 ? itemSel(0, true) + itemSel(1, true) : itemSel(0, false)) + '</div>';
      };
      var pills = function () {
        return '<div class="pk-pack__more"><p class="pk-pack__more-label">Color</p>' + [0, 1].map(function (i) {
          return '<div class="pk-pack__pickrow"><span class="pk-pack__num">#' + (i + 1) + '</span><div class="pk-pills">' + self.fabric.colours.map(function (c) {
            var v = vFor(c.name), out = !v || !v.available, on = c.name === st.items[i].colour;
            return '<button type="button" class="pk-pill' + (on ? ' is-active' : '') + (out ? ' is-out' : '') + '" data-pk-icolour="' + esc(c.name) + '" data-pk-i="' + i + '" aria-pressed="' + on + '"' + (out ? ' disabled' : '') + '><span class="pk-pill__dot"' + (c.hex ? ' style="background:' + esc(c.hex) + '"' : '') + '>' + (!c.hex && c.swatch ? '<img src="' + c.swatch + '" alt="" loading="lazy" width="40" height="40">' : '') + '</span>' + esc(c.name) + '</button>';
          }).join('') + '</div></div>';
        }).join('') + '</div>';
      };
      box.innerHTML = cards.map(function (c) {
        var on = c.n === st.pack;
        return '<div class="pk-pack' + (on ? ' is-active' : '') + '" role="radio" tabindex="0" aria-checked="' + on + '" data-pk-pack="' + c.n + '">' +
          (c.badge ? '<span class="pk-pack__badge">' + esc(c.badge) + '</span>' : '') +
          '<div class="pk-pack__top"><span class="pk-pack__radio" aria-hidden="true"></span>' +
          '<span class="pk-pack__line"><span class="pk-pack__title">' + esc(c.title) + '</span>' + (c.n === 2 ? '<span class="pk-pack__each">' + (c.sub ? esc(c.sub) + '\u00a0\u00b7 ' : '') + self.money(Math.round(c.now / 2)) + ' each</span>' : '') + (c.callout ? '<span class="pk-pack__callout">' + esc(c.callout) + '</span>' : '') + (c.note ? '<span class="pk-pack__note">' + esc(c.note) + '</span>' : '') + '</span>' +
          '<span class="pk-pack__prices"><span class="pk-pack__now">' + self.money(c.now) + '</span>' + (c.was > c.now ? '<s class="pk-pack__was">' + self.wasMoney(c.was, c.now) + '</s>' : '') + '</span></div>' +
          (on ? selects(c.n) : '') + '</div>';
      }).join('');
    }
    duoInitItems() {
      var self = this, c1 = this.state.colour, sz = this.state.size;
      var inSize = function (n) { var v = self.vIndex[sz + '|' + n]; return v && v.available; };
      /* Round 122 (owner): #2 starts in the same colour as #1; another colour only if #1's is not in stock in this size. */
      var c2 = inSize(c1) ? c1 : (this.fabric.colours.find(function (c) { return inSize(c.name); }) || { name: c1 }).name;
      this.state.items = [{ colour: c1, size: '' }, { colour: c2, size: '' }];
      this._pin = [false, false];
    }
    renderSingle() {
      var self = this, st = this.state;
      if (this.duo) this.renderDuo();
      var box = this.querySelector('[data-pk-sizecards]');
      if (box) {
        box.innerHTML = this.sizeList.map(function (sz) {
          var v = self.vIndex[sz + '|' + st.colour];
          var out = !v || !v.available, on = sz === st.size, p = self.sizeParts(sz);
          var vp = v ? v.price - self.duoOff(v.price, v) : 0, vw = v ? Math.max(v.compare, v.price) : 0;
          var price = v ? '<b>' + self.money(vp) + '</b>' + (vw > vp ? '<s>' + self.money(vw) + '</s>' : '') : '';
          /* Round 45: one row per size, name and measurements left, price right. */
          return '<button type="button" class="pk-sizecard' + (on ? ' is-active' : '') + (out ? ' is-out' : '') + '" role="radio" aria-checked="' + on + '" data-pk-sizecard="' + esc(sz) + '"><span class="pk-sizecard__main"><span class="pk-sizecard__name">' + esc(p.name) + '</span>' + (p.dims ? '<span class="pk-sizecard__dims">' + esc(p.dims) + '</span>' : '') + '</span><span class="pk-sizecard__price">' + (out ? '<span class="pk-sizecard__out">Sold out</span>' : price) + '</span></button>';
        }).join('');
      }
      var fit = this.querySelector('[data-pk-fit]');
      var cur = this.sizeParts(st.size);
      /* Round 45: each size row shows its measurements, so the separate fit line stays hidden. */
      if (fit) { fit.textContent = ''; fit.hidden = true; }
      var q = this.querySelector('[data-pk-qty]');
      if (q) { q.querySelector('output').textContent = st.qty; q.querySelector('[data-pk-qty-minus]').disabled = st.qty <= 1; }
    }
    colourAvailable(name) { return this.fabric.variants.some(function (v) { return v.colour === name && v.available; }); }
    /* Round 115: "New" tags on fabrics and colors, from the k_new_fabrics / k_new_colours settings. */
    newList(s) { return String(s || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); }
    isNewFabric(f) { var l = this.newList(this.D.newFabrics); return l.indexOf(String(f.name).toLowerCase()) !== -1 || l.indexOf(String(f.handle).toLowerCase()) !== -1; }
    isNewColour(name, f) {
      f = f || this.fabric;
      var c = String(name).toLowerCase(), fn = String(f.name).toLowerCase(), fh = String(f.handle).toLowerCase();
      return this.newList(this.D.newColours).some(function (x) {
        var p = x.split('/');
        if (p.length < 2) return x === c;
        return p[p.length - 1].trim() === c && [fn, fh].indexOf(p.slice(0, -1).join('/').trim()) !== -1;
      });
    }
    newTag() { return '<span class="pk-new" aria-hidden="true">' + esc(this.D.newText || 'New') + '</span>'; }
    renderFabrics() {
      var box = this.querySelector('[data-pk-fabrics]');
      var self = this;
      box.innerHTML = this.D.fabrics.map(function (f) {
        var on = f.handle === self.fabric.handle;
        /* Round 45: blanket (duo) pages show photo tiles; the picked fabric's detail sits by the label. */
        /* Round 61: tiles on every page (owner). */
        var nw = self.isNewFabric(f);
        return '<button type="button" class="pk-ftile' + (on ? ' is-active' : '') + (nw ? ' is-new' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(f.name + ', ' + f.detail + (nw ? ', ' + (self.D.newText || 'New') : '')) + '" data-pk-fabric="' + esc(f.handle) + '">' + (nw ? self.newTag() : '') + '<span class="pk-ftile__img">' + (f.image ? '<img src="' + esc(f.image) + '" alt="" width="192" height="192">' : '') + '</span><span class="pk-ftile__name">' + esc(f.name) + '</span></button>';
      }).join('');
      box.classList.add('pk-pick__fabrics--tiles');
      /* Round 48: the tiles already name each fabric, so the label shows no value. */
      /* Owner, 30 Oct 2026 (Design 1, "Select Fabric: (show the fabric selected)"): the numbered steps name the fabric. */
      /* Owner, 31 Oct 2026: mats and blankets name the fabric too ("Select fabric: name"). */
      this.querySelector('[data-pk-fabric-name]').textContent = this.fabric.name;
      var grp = box.closest('.pk-pick__group');
      if (grp) grp.hidden = this.D.fabrics.length < 2;
    }
    renderColours() {
      var box = this.querySelector('[data-pk-colours]');
      var self = this;
      box.innerHTML = this.fabric.colours.map(function (c) {
        var on = c.name === self.state.colour;
        var out = !self.colourAvailable(c.name);
        var nw = self.isNewColour(c.name);
        return '<button type="button" class="pk-swatch' + (on ? ' is-active' : '') + (out ? ' is-out' : '') + (nw ? ' is-new' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(c.name + (nw ? ', ' + (self.D.newText || 'New') : '') + (out ? ', sold out' : '')) + '" data-pk-colour="' + esc(c.name) + '" title="' + esc(c.name) + (out ? ' (sold out)' : '') + '">' + (nw ? self.newTag() : '') + '<span class="pk-swatch__img"' + (c.hex ? ' style="background:' + esc(c.hex) + '"' : '') + '>' + (!c.hex && c.swatch ? '<img src="' + c.swatch + '" alt="" loading="lazy" width="60" height="60">' : '') + '</span><span class="pk-swatch__name">' + esc(c.name) + '</span></button>';
      }).join('');
    }
    /* Round 124: true when no colour has the sold-out sizes in stock (then "Sold Out", not "...In This Color"). */
    soldOutEverywhere(ls) {
      var self = this;
      var outs = (ls || []).filter(function (l) { return !l.variant || !l.variant.available; });
      if (!outs.length) return false;
      return outs.every(function (l) {
        return !self.fabric.colours.some(function (c) {
          var v = (self.duo || self.single) ? self.vIndex[l.size + '|' + c.name] : self.variant(l.piece, l.size, c.name);
          return v && v.available;
        });
      });
    }
    lines() {
      if (this.duo) {
        var me = this;
        return this.state.items.slice(0, this.state.pack).map(function (it, i) { var sz = i === 0 ? me.state.size : me.size2(); return { piece: me.D.itemName + ' ' + (i + 1), size: sz, colour: it.colour, qty: 1, variant: it.colour && sz ? me.vIndex[sz + '|' + it.colour] || null : null, incomplete: !it.colour || !sz }; });
      }
      if (this.single) {
        if (!this.state.size) return [];
        return [{ piece: 'item', size: this.state.size, qty: this.state.qty, variant: this.vIndex[this.state.size + '|' + this.state.colour] || null }];
      }
      if (this.q) return this.ladLines();
      var self = this, out = [];
      ['seat', 'back', 'chaise'].forEach(function (p) {
        var st = self.state[p];
        if (!st.qty) return;
        out.push({ piece: p, size: st.size, qty: st.qty, variant: self.variant(p, st.size, self.state.colour) });
      });
      return out;
    }
    label() {
      if (this.duo) return this.state.pack === 2 ? '2 ' + this.D.itemPlural : '1 ' + this.D.itemName;
      if (this.single) return (this.state.qty > 1 ? this.state.qty + ' × ' : '') + this.sizeParts(this.state.size).name;
      var s = this.state, parts = [];
      var name = { seat: ['Seat', 'Seats'], back: ['Back', 'Backs'], chaise: ['Chaise', 'Chaises'] };
      if (this.q) return this.ladLines().map(function (l) { return l.qty + ' ' + name[l.piece][l.qty === 1 ? 0 : 1] + ' (' + l.size + ')'; }).join(' + ');
      ['seat', 'back', 'chaise'].forEach(function (p) {
        if (s[p].qty) parts.push(s[p].qty + ' ' + name[p][s[p].qty === 1 ? 0 : 1] + ' (' + s[p].size + ')');
      });
      return parts.join(' + ');
    }
    renderPrice() {
      /* Round 131: same rule as the collection and search cards. Covers: the cheapest seat cover; other items:
         the cheapest variant. In-stock variants first, all variants when none is in stock. */
      /* 2 Nov 2026 (owner): the price line reads "From" instead of "as low as".
         28 Oct 2026, piece pricing: "From" the line's lowest 6+ price, its compare-at per piece, and the save pill. */
      var ln = this.ladLine();
      if (ln && this.SS) {
        var me = this, lo = null;
        Object.keys(ln).forEach(function (k) { var m = /^(Seat|Back|Chaise) Cover \((\w+)\)$/.exec(k), r = m && me.ladRow(m[1].toLowerCase(), m[2]); if (r && (!lo || r[0] < lo[0])) lo = r; });
        var pe = this.article.querySelector('[data-pk-price]');
        if (pe && lo) pe.innerHTML = '<span class="pk-asl">From</span> <span class="pk-vh">Sale price: </span><span class="pk__now-live pk-red">' + this.money(this.ladCents(lo[0])) + '</span>' + (lo[4] > lo[0] ? ' <s class="pk__was-live"><span class="pk-vh">Compare at: </span>' + this.money(this.ladCents(lo[4])) + '/ea</s>' : '<small>/ea</small>');
        return;
      }
      if (ln) {
        var top = this.L.breaks.length - 1, best = null;
        Object.keys(ln).forEach(function (k) { if (!best || ln[k][top] < best[top]) best = ln[k]; });
        var pel = this.article.querySelector('[data-pk-price]');
        if (pel && best) pel.innerHTML = '<span class="pk-asl">From</span> <span class="pk-vh">Sale price: </span><span class="pk__now-live pk-red">' + this.money(this.ladCents(best[top])) + '</span> <s class="pk__was-live"><span class="pk-vh">Compare at: </span>' + this.money(this.ladCents(best[top + 1])) + '/ea</s>' + (this.D.ladderSave ? ' <span class="pk-save">' + esc(this.D.ladderSave) + '</span>' : '');
        return;
      }
      var vs = this.fabric.variants, inStock = vs.filter(function (v) { return v.available; });
      var pool = inStock.length ? inStock : vs;
      var seats = pool.filter(function (v) { return /^Seat Cover/.test(v.size || ''); });
      if (!this.single && seats.length) pool = seats;
      var first = pool.reduce(function (m, v) { return !m || v.price < m.price ? v : m; }, null);
      var el = this.article.querySelector('[data-pk-price]');
      if (!el || !first) return;
      var html = '<span aria-hidden="true">From </span>';
      if (first.compare > first.price) html += '<s class="pk__was-live"><span class="pk-vh">Original price: </span>' + this.money(first.compare) + '</s> ';
      html += '<span class="pk-vh">Sale price: </span><span class="pk__now-live">' + this.money(first.price) + '</span>';
      el.innerHTML = html;
    }
    render() {
      var self = this, D = this.D;
      this.renderPrice();
      /* Round 121: the title shows up to the first " | " ("... | Last Chance"), like the simple pages. */
      this.article.querySelectorAll('[data-pk-title]').forEach(function (t) { t.textContent = String(self.fabric.title).split(' | ')[0]; });
      fitTitles();
      this.querySelector('[data-pk-colour-label]').textContent = this.state.colour + (this.colourAvailable(this.state.colour) ? '' : ' · Sold out');
      if (this.single) this.renderSingle();
      var lad = this.ladState();
      this.renderLadder(lad);

      ['seat', 'back', 'chaise'].forEach(function (p) {
        var row = self.querySelector('[data-pk-row="' + p + '"]');
        if (!row) return;
        var st = self.state[p];
        var sizes = self.sizes[p];
        row.hidden = !sizes.length;
        var v = self.variant(p, st.size, self.state.colour);
        row.querySelector('output').textContent = st.qty;
        row.querySelector('[data-pk-minus]').disabled = st.qty === 0;
        row.classList.toggle('is-on', st.qty > 0);
        var price = row.querySelector('[data-pk-row-price]');
        var lr = lad && self.ladRow(p, st.size);
        if (v && lr) {
          /* Piece pricing: this size at the cart's tier, with the 1-piece price crossed out once a tier applies. */
          price.innerHTML = '<b>' + self.money(self.ladCents(lr[lad.ti])) + '</b>' + (lad.ti > 0 ? ' <s>' + self.money(self.ladCents(lr[0])) + '</s>' : '') + (v.available ? '' : ' · Sold out');
        } else if (v) {
          price.innerHTML = '<b>' + self.money(v.price) + '</b>' + (v.compare > v.price ? ' <s>' + self.money(v.compare) + '</s>' : '') + (v.available ? '' : ' · Sold out');
        } else {
          price.textContent = 'Not available';
        }
        var sz = row.querySelector('[data-pk-sizes]');
        sz.innerHTML = sizes.map(function (s) {
          var on = s === st.size;
          var sv = self.variant(p, s, self.state.colour);
          var out = !sv || !sv.available;
          return '<button type="button" class="pk-size' + (on ? ' is-active' : '') + (out ? ' is-out' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + SIZE_NAMES[s] + (out ? ', sold out' : '') + '" data-pk-size="' + s + '">' + s + '</button>';
        }).join('');
        var dims = (D.dims[p] || {})[st.size];
        var dimsEl = row.querySelector('[data-pk-row-dims]');
        dimsEl.textContent = dims ? 'Fits ' + dims : '';
        var auto = self._autoSize && self._autoSize[p];
        if (auto && auto.to === st.size && auto.colour === self.state.colour && st.qty) {
          dimsEl.textContent = (SIZE_NAMES[auto.from] || auto.from) + ' is sold out in ' + auto.colour + ', so ' + (SIZE_NAMES[auto.to] || auto.to) + ' is picked. Check it fits your cushions.' + (dims ? ' Fits ' + dims + '.' : '');
          dimsEl.hidden = false;
          return;
        }
        dimsEl.hidden = !dims || !st.qty;
      });

      if (this.q) this.renderPieces(lad);
      else this.querySelectorAll('[data-pk-layouts] .pk-chip').forEach(function (b) {
        var on = +b.dataset.seat === self.state.seat.qty && +b.dataset.back === self.state.back.qty && +b.dataset.chaise === self.state.chaise.qty;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
      });

      var ls = this.lines(), total = 0, was = 0, missing = [], incomplete = false;
      ls.forEach(function (l) {
        if (l.incomplete) { incomplete = true; return; }
        if (!l.variant || !l.variant.available) { missing.push(l.colour ? l.piece + ' (' + l.colour + ', ' + self.sizeParts(l.size).name + ')' : l.piece + ' (' + l.size + ')'); return; }
        var llr = lad && self.ladRow(l.piece, l.size);
        if (llr) { total += self.ladCents(llr[lad.ti]) * l.qty; was += self.ladCents(self.SS ? llr[4] : llr[0]) * l.qty; return; }
        total += (l.variant.price - (self.setPricing() ? 0 : self.duoOff(l.variant.price, l.variant))) * l.qty;
        was += Math.max(l.variant.compare, l.variant.price) * l.qty;
      });
      if (!missing.length && !incomplete) total -= this.duoFreeOff(ls.map(function (l) { return l.variant.price; }));
      if (!missing.length && !incomplete && this.duo && this.setPricing() && this.state.pack === 2) {
        var pv = [];
        ls.forEach(function (l) { for (var q = 0; q < l.qty; q++) pv.push(l.variant); });
        if (pv.length === 2) total -= this.pairOff(pv[0], pv[1]);
      }
      var ok = ls.length > 0 && !missing.length && !incomplete;
      var sum = this.querySelector('[data-pk-sum]');
      if (incomplete) sum.textContent = '';
      else if (!ls.length) sum.textContent = 'Add the covers you need above.';
      else if (!ok) sum.textContent = '';
      else sum.innerHTML = '<span>' + esc(this.label()) + '</span><b>' + this.money(total) + (was > total ? ' <s>' + this.wasMoney(was, total) + '</s>' : '') + '</b>';
      if (lad) { var tl = this.querySelector('[data-pk-tier]'); if (tl) tl.textContent = ''; }
      else this.renderTiers(ok ? total : 0);
      /* Round 168: pack: true while the 2-item Wash & Swap Pack is picked. Since 23 Oct Spend & Save stacks on the pack price. */
      this.ssEmit({ pack: !!(ok && this.duo && this.state.pack === 2), total: ok ? total : 0, hints: this.ssHints(), key: ok ? ls.map(function (l) { return l.variant.id + 'x' + l.qty; }).join(',') + '=' + total : '' });

      var issue = this.querySelector('[data-pk-issue]');
      issue.hidden = !missing.length;
      issue.textContent = !missing.length ? '' : (this.duo && this.state.pack === 2) ? 'Sold out: ' + missing.join(', ') + '. Pick another colour or size.' : this.state.colour + ' is sold out in ' + (this.single ? this.sizeParts(this.state.size).name : missing.join(', ')) + '. Pick another colour or size.';

      /* Owner, 30 Oct 2026: nothing picked and every size shown is sold out in this colour: the main button offers
         Notify Me for those sizes instead of "Select At Least 1 Cover". */
      var rowsNow = this.L ? (this.rows || []) : [];
      this._notify = !ls.length && rowsNow.length && rowsNow.every(function (r) { var rv = self.variant(r.p, r.z, self.state.colour); return !rv || !rv.available; })
        ? this.notifyItems(rowsNow.map(function (r) { return r.p + '|' + r.z; })) : [];
      var notifyMode = this._notify.length > 0;
      var atc = this.querySelector('[data-pk-atc]');
      /* Owner, 29 Oct 2026 (K17 B: "In Stock: Ready to Ship" above the button had the best conversion, +15%):
         shown while the chosen colour has stock and nothing picked is sold out. */
      /* 30 Oct 2026: the stock line sits in the assurance bar under the picker, outside pk-picker. */
      var stockEl = this.querySelector('[data-pk-instock]') || (this.article && this.article.querySelector('[data-pk-instock]'));
      if (stockEl) stockEl.hidden = !(this.colourAvailable(this.state.colour) && !missing.length && !notifyMode);
      atc.disabled = !(ok || notifyMode) || this.adding;
      /* Owner, 31 Oct 2026: greyed out while there is nothing to add. */
      atc.classList.toggle('is-empty', !this.adding && !ok && !notifyMode);
      var wasHtml = was > total ? ' <s class="pk-btn__was">' + this.wasMoney(was, total) + '</s>' : '';
      /* Piece pricing: "Add 6 Covers — $131.94", with the 1-piece total crossed out. */
      var addLabel = lad ? 'Add ' + lad.sel + (lad.sel === 1 ? ' Cover' : ' Covers') : 'Add To Cart';
      if (this.adding) atc.textContent = 'Adding…';
      else if (ok) atc.innerHTML = addLabel + ' — ' + this.money(total) + wasHtml;
      else if (notifyMode) atc.textContent = 'Notify Me When Available';
      else if (incomplete) atc.textContent = 'Select Color & Size';
      else atc.textContent = ls.length ? (this.soldOutEverywhere(ls) ? 'Sold Out' : 'Sold Out In This Color') : (this.single ? 'Choose A Size' : lad ? 'Select At Least 1 Cover' : 'Add Your Covers');

      var bar = this.article.querySelector('[data-pk-sticky]') || document.querySelector('[data-pk-sticky="#' + this.article.id + ' [data-pk-atc]"]');
      if (bar) {
        /* QA 17 Oct (M1): the sticky button adds to the cart like the main one; when it can't, it says why. */
        var miss = ok ? null : this.missingInfo();
        var meta = bar.querySelector('[data-pk-sticky-meta]');
        if (meta) meta.textContent = miss ? miss.text : this.duo ? this.label() : this.state.colour + (ls.length ? ' · ' + this.label() : '');
        var sl = bar.querySelector('[data-pk-sticky-label]');
        if (sl) { if (this.adding) sl.textContent = 'Adding…'; else if (ok) sl.innerHTML = addLabel + ' — ' + this.money(total) + wasHtml; else if (notifyMode) sl.textContent = 'Notify Me When Available'; else sl.textContent = miss ? miss.label : 'Choose Your Covers'; }
      }
      this.fitGuide();
    }
    /* QA 17 Oct (M6): the blanket size guide only names sizes this fabric is sold in. A size it doesn't
       make moves up to the next length it does make at the same height ("between two sizes, go up");
       a column with no size at all is hidden. */
    fitGuide() {
      if (!this.single || this._guideFor === this.fabric.handle) return;
      var art = this.article;
      var table = art && art.querySelector('.pk-sg--blanket .pk-sg__table');
      if (!table) return;
      this._guideFor = this.fabric.handle;
      var made = {};
      (this.sizeList || []).forEach(function (sz) {
        var m = /(\d+)\s*x\s*(\d+)/i.exec(sz);
        if (m) (made[m[1]] = made[m[1]] || []).push(+m[2]);
      });
      Object.keys(made).forEach(function (h) { made[h].sort(function (a, b) { return a - b; }); });
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      var cols = rows.length ? rows[0].children.length : 0;
      var used = [];
      rows.forEach(function (tr, ri) {
        Array.prototype.forEach.call(tr.children, function (cell, ci) {
          if (cell._pkHome === undefined) cell._pkHome = cell.innerHTML;
          cell.innerHTML = cell._pkHome;
          if (ri === 0 || ci === 0) return;
          var m = /^\s*(\d+)\s*x\s*([\d\s]+(?:or\s*\d+\s*)*)in\s*$/i.exec(cell.textContent);
          if (!m) return;
          var h = m[1], lens = (m[2].match(/\d+/g) || []).map(Number), have = made[h] || [];
          var out = [];
          lens.forEach(function (l) { var x = have.find(function (y) { return y >= l; }); if (x && out.indexOf(x) === -1) out.push(x); });
          cell.textContent = out.length ? h + ' x ' + out.join(' or ') + ' in' : '–';
          if (out.length) used[ci] = true;
        });
      });
      for (var ci = 1; ci < cols; ci++) {
        var hide = !used[ci];
        rows.forEach(function (tr) { var c = tr.children[ci]; if (c) c.hidden = hide; });
      }
    }
    renderTiers(total) {
      /* Round 158: the tiers are in US dollars; outside the US, convert them at Shopify's rate. */
      var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) || 1;
      var D = this.D, t = D.tiers.map(function (x) { return x * 100 * rate; });
      var next = -1;
      for (var i = 0; i < t.length; i++) { if (total < t[i]) { next = i; break; } }
      var tier = this.querySelector('[data-pk-tier]');
      if (total === 0) tier.textContent = '';
      else if (next === -1) tier.textContent = 'Free shipping and ' + D.tierLabels[t.length - 1] + ' applied at checkout';
      else if (next === 0) tier.textContent = 'Add ' + this.money(t[0] - total) + ' for free shipping';
      else tier.textContent = (next > 1 ? D.tierLabels[next - 1] + ' unlocked · ' : 'Free shipping unlocked · ') + 'Add ' + this.money(t[next] - total) + ' for ' + D.tierLabels[next];
      tier.classList.toggle('is-done', total > 0 && next === -1);
      var bar = this.querySelector('[data-pk-tier-bar]');
      if (bar) bar.style.width = Math.min(100, total / t[t.length - 1] * 100) + '%';
      var marks = this.querySelector('[data-pk-tier-marks]');
      if (marks && !marks.children.length) {
        marks.innerHTML = D.tiers.map(function (x, i) { return '<span data-at="' + x + '">$' + x + '<br>' + esc(D.tierLabels[i]) + '</span>'; }).join('');
      }
      if (marks) marks.querySelectorAll('span').forEach(function (s) { s.classList.toggle('is-done', total >= +s.dataset.at * 100); });
    }
    syncGallery(jump) {
      var self = this;
      var c = this.fabric.colours.find(function (x) { return x.name === self.state.colour; });
      if (this.gallery && this.gallery.setColour) this.gallery.setColour(c, this.fabric, jump);
    }
    /* Fabric switch, like the live picker: gallery, Overview/Materials text, rating and review quote follow the picked fabric. */
    switchPage(next) {
      var art = this.article;
      if (!art) return;
      var home = !!next.current;
      /* Round 124 (QA 20 Oct): the address and tab title follow the fabric, so refresh, share and back keep it. */
      if (!this._docTitle0) this._docTitle0 = document.title;
      try {
        if (next.handle && window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.pathname = u.pathname.replace(/\/products\/[^\/?#]+/, '/products/' + next.handle);
          history.replaceState(history.state, '', u.toString());
        }
      } catch (err) { console.error('[pdp-k] could not update the address for the picked fabric', err); }
      document.title = home ? this._docTitle0 : String(next.title || '').split(' | ')[0] + ' | Nolan Interior';
      if (this.gallery && this.gallery.useFabric) this.gallery.useFabric(next, home);
      /* Round 58: the photo pill follows the fabric: "Best seller" for listed handles, else the sale text. */
      var badge = document.querySelector('[data-pk-badge]');
      if (badge) {
        var best = (badge.getAttribute('data-best-handles') || '').indexOf(',' + next.handle + ',') !== -1;
        /* Round 95: "New" for handles in k_gal_new; otherwise the sale pill when the picked fabric is on sale. */
        var isNew = (badge.getAttribute('data-new-handles') || '').indexOf(',' + next.handle + ',') !== -1;
        var saleTxt = badge.hasAttribute('data-sale-text') ? (next.onSale === false ? '' : badge.getAttribute('data-sale-text')) : badge.getAttribute('data-sale');
        var txt = best ? 'Best seller' : isNew ? 'New' : saleTxt || '';
        badge.textContent = txt;
        badge.hidden = !txt;
      }
      var D = this.D;
      art.querySelectorAll('.pk-acc').forEach(function (acc) {
        var t = acc.querySelector('.pk-acc__title');
        var c = acc.querySelector('.pk-acc__content');
        if (!t || !c) return;
        if (c._home === undefined) c._home = c.innerHTML;
        var title = t.textContent.trim().toLowerCase();
        var o = home ? null : (D.fabricAcc || []).find(function (x) { return x.handle === next.handle && x.title.toLowerCase() === title; });
        /* The page's own text belongs to its own fabric. Another fabric with no line of its own gets the
           template's text, which is written for the template's first fabric (accBase). */
        var base = !home && !o ? (D.accBase || []).find(function (x) { return x.title.toLowerCase() === title; }) : null;
        c.innerHTML = o ? o.html : base ? base.html : c._home;
      });
      /* QA 17 Oct (M5): checklist, size guide intro, feature, diagram and FAQ text per fabric (data-pk-falt). */
      document.querySelectorAll('[data-pk-falt]').forEach(function (el) {
        var map;
        try { map = JSON.parse(el.getAttribute('data-pk-falt')); } catch (e) { return; }
        var html = Object.prototype.hasOwnProperty.call(map, next.handle) ? map[next.handle] : map['*'];
        if (html == null) return;
        el.innerHTML = html;
      });
      /* Round 159: per-product photos in the split sections (fabric_text image:N, data-pk-fimg). */
      document.querySelectorAll('[data-pk-fimg]').forEach(function (el) {
        var map;
        try { map = JSON.parse(el.getAttribute('data-pk-fimg')); } catch (e) { return; }
        var key = Object.prototype.hasOwnProperty.call(map, next.handle) ? next.handle : '*';
        if (el._fimg === key) return;
        el._fimg = key;
        var old = el.querySelector('video');
        if (old) old.pause();
        el.innerHTML = map[key] || '';
        el.classList.toggle('pk-split__video', !!el.querySelector('video'));
        el.querySelectorAll('video[data-poster]').forEach(function (v) { v.setAttribute('poster', v.getAttribute('data-poster')); v.removeAttribute('data-poster'); });
        var v = el.querySelector('video');
        if (v && el.classList.contains('is-active') && !reduceMotion.matches) playQuietly(v);
      });
      art.querySelectorAll('.pk__review-wrap, .pk__review[data-pk-review-hide], .pk__review[data-pk-review-home]').forEach(function (w) {
        var only = w.getAttribute('data-pk-review-hide');
        w.hidden = only != null ? only.indexOf(',' + next.handle + ',') !== -1 : !home;
      });
      if (window.pkRevSync) window.pkRevSync(art);
      var link = art.querySelector('.pk__rating-live');
      if (link) {
        if (link._home === undefined) link._home = { html: link.innerHTML, label: link.getAttribute('aria-label'), hidden: link.hidden };
        if (home) { link.innerHTML = link._home.html; link.setAttribute('aria-label', link._home.label); link.hidden = link._home.hidden; }
        else {
          var r = parseFloat(next.rating) || 0, n = parseInt(next.ratingCount, 10) || 0;
          link.hidden = !n;
          var star = 'M12 2.8l2.75 5.9 6.45.75-4.8 4.4 1.3 6.35L12 17.05 6.3 20.2l1.3-6.35-4.8-4.4 6.45-.75z';
          var stars = '';
          for (var i = 1; i <= 5; i++) {
            var d = r - (i - 1), fill = d >= 0.75 ? 'full' : d >= 0.25 ? 'half' : 'none';
            var cid = 'pk-half-x-' + i;
            stars += '<svg viewBox="0 0 24 24" class="is-' + fill + '"><defs><clipPath id="' + cid + '"><rect x="0" y="0" width="12" height="24"/></clipPath></defs><path class="o" d="' + star + '"/>' + (fill === 'half' ? '<path class="f" clip-path="url(#' + cid + ')" d="' + star + '"/>' : '') + '</svg>';
          }
          link.innerHTML = '<span class="pk__stars-live" aria-hidden="true">' + stars + '</span><span class="pk__rating-text"><span class="pk__rating-short">(' + n + ')</span><span class="pk__rating-long">' + n + ' reviews</span></span>';
          link.setAttribute('aria-label', r.toFixed(2) + ' out of 5 stars, ' + n + ' reviews');
        }
      }
    }
    bind() {
      var self = this;
      /* Clicks inside the picker re-render it, so the clicked node can be detached by now; only close for real outside clicks. */
      document.addEventListener('click', function (e) { if (self._ddOpen != null && e.target.isConnected && !self.contains(e.target)) { self._ddOpen = null; self.render(); } });
      /* Round 120: iPhone Safari sends no click for taps on plain text, so also close on any touch outside the open
         dropdown (this starts a scroll too). Only hide it here, no re-render, so the touched element still gets its tap. */
      document.addEventListener('pointerdown', function (e) {
        if (self._ddOpen == null) return;
        var open = self.querySelector('.pk-dd.is-open');
        if (open && open.contains(e.target)) return;
        if (e.target.closest && e.target.closest('[data-pk-ddbtn]')) return;
        self._ddOpen = null;
        if (open) {
          open.classList.remove('is-open', 'pk-dd--up');
          var ol = open.querySelector('.pk-dd__list'); if (ol) ol.hidden = true;
          var ob = open.querySelector('[data-pk-ddbtn]'); if (ob) ob.setAttribute('aria-expanded', 'false');
        }
      }, true);
      this.addEventListener('keydown', function (e) {
        if (self._ddOpen == null) return;
        var list = self.querySelector('.pk-dd.is-open .pk-dd__list');
        if (e.key === 'Escape') { var oi = self._ddOpen; self._ddOpen = null; self.render(); var b = self.querySelector('[data-pk-ddbtn="' + oi + '"]'); if (b) b.focus(); e.preventDefault(); return; }
        if (list && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
          var os = Array.prototype.slice.call(list.querySelectorAll('.pk-dd__opt:not([disabled])'));
          var k = os.indexOf(document.activeElement);
          k = e.key === 'ArrowDown' ? Math.min(os.length - 1, k + 1) : Math.max(0, k - 1);
          if (os[k]) os[k].focus();
          e.preventDefault();
        }
      });
      this.addEventListener('change', function (e) {
        var s2 = e.target.closest && e.target.closest('[data-pk-isel]');
        if (!s2) return;
        var ii = +s2.dataset.pkI, kind = s2.dataset.pkIsel, st = self.state;
        if (kind === 'colour') {
          if (ii === 0) { st.colour = s2.value; self.renderColours(); self._keep0 = 'colour'; }
          else { st.items[1].colour = s2.value; self._keep1 = 'colour'; }
          self.pinItem(ii);
          var co = self.fabric.colours.find(function (x) { return x.name === s2.value; });
          if (co && self.gallery && self.gallery.setColour) self.gallery.setColour(co, self.fabric, true);
        } else {
          if (ii === 0) { if (!st.items[1].size) st.items[1].size = st.size; st.size = s2.value; self._keep0 = 'size'; }
          else { st.items[1].size = s2.value; self._keep1 = 'size'; }
          self.pinItem(ii);
        }
        self.render();
        var again = self.querySelector('[data-pk-isel="' + kind + '"][data-pk-i="' + ii + '"]');
        /* iOS reopens its picker when a select gets focus, so only restore focus for mouse and keyboard users. */
        if (again && !window.matchMedia('(pointer: coarse)').matches) again.focus();
      });
      this.addEventListener('click', function (e) {
        var f = e.target.closest('[data-pk-fabric]');
        if (f) {
          var next = self.D.fabrics.find(function (x) { return x.handle === f.dataset.pkFabric; });
          if (!next || next.handle === self.fabric.handle) return;
          self.fabric = next;
          /* Owner, 29 Oct 2026: until the shopper picks a colour, each fabric opens on its best-selling colour (k_colour_best). */
          var bc = self.D.colourBest && self.D.colourBest[next.handle];
          if (bc && !self._userColour && next.variants.some(function (v) { return v.colour === bc && v.available; })) self.state.colour = bc;
          self.index();
          self._userSize = {};
          self.pickInStock();
          self.idleSizes();
          if (self.duo) self.duoInitItems();
          self.renderFabrics();
          self.renderColours();
          self.render();
          self.switchPage(next);
          self.syncGallery(false);
          return;
        }
        var c = e.target.closest('[data-pk-colour]');
        if (c) {
          self.state.colour = c.dataset.pkColour;
          self._userColour = true;
          self._autoSize = null;
          self.idleSizes();
          self.pinItem(0);
          self.querySelectorAll('[data-pk-colour]').forEach(function (b) { var on = b === c; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
          self.render();
          self.syncGallery(true);
          return;
        }
        var ddb = e.target.closest('[data-pk-ddbtn]');
        if (ddb) {
          var di = ddb.dataset.pkDdbtn; self._ddOpen = self._ddOpen === di ? null : di; self.render();
          var nb = self.querySelector('[data-pk-ddbtn="' + di + '"]'); if (nb) nb.focus({ preventScroll: true });
          /* Round 123 (owner, 20 Oct 2026: "show it dropped down instead"): the list always opens downward. If it does not
             fit on screen, the page scrolls smoothly just enough to show it (above the sticky bar); no scroll if it fits. */
          var od = self.querySelector('.pk-dd.is-open'), ls = od && od.querySelector('.pk-dd__list');
          if (ls) {
            var lb = ls.getBoundingClientRect().bottom + 12;
            var bar = document.querySelector('.pk-sticky.is-visible'), floor = window.innerHeight - (bar ? bar.offsetHeight : 0);
            if (lb > floor) {
              var by = Math.min(lb - floor, od.getBoundingClientRect().top - 70);
              if (by > 0) {
                var sy0 = window.scrollY;
                window.scrollBy({ top: by, behavior: 'smooth' });
                /* Fallback: if smooth scrolling does not run (reduced motion, some in-app browsers), jump instead. */
                setTimeout(function () { if (Math.abs(window.scrollY - sy0) < 1) window.scrollBy(0, by); }, 450);
              }
            }
          }
          return;
        }
        var copt = e.target.closest('[data-pk-icopt]');
        if (copt) {
          var ci = +copt.dataset.pkI, cn = copt.dataset.pkIcopt, st3 = self.state;
          if (ci === 0) { st3.colour = cn; self.renderColours(); self._keep0 = 'colour'; }
          else { st3.items[1].colour = cn; self._keep1 = 'colour'; }
          self.pinItem(ci);
          self._ddOpen = null; self.render();
          var cco = self.fabric.colours.find(function (x) { return x.name === cn; });
          if (cco && self.gallery && self.gallery.setColour) self.gallery.setColour(cco, self.fabric, true);
          var cb = self.querySelector('[data-pk-ddbtn="c' + ci + '"]'); if (cb) cb.focus({ preventScroll: true });
          return;
        }
        var dopt = e.target.closest('[data-pk-iopt]');
        if (dopt) {
          var oi = +dopt.dataset.pkI, st2 = self.state;
          if (oi === 0) { if (!st2.items[1].size) st2.items[1].size = st2.size; st2.size = dopt.dataset.pkIopt; self._keep0 = 'size'; }
          else { st2.items[1].size = dopt.dataset.pkIopt; self._keep1 = 'size'; }
          self.pinItem(oi);
          self._ddOpen = null; self.render();
          var back = self.querySelector('[data-pk-ddbtn="' + oi + '"]'); if (back) back.focus({ preventScroll: true });
          return;
        }
        if (self._ddOpen != null && !e.target.closest('.pk-dd')) { self._ddOpen = null; self.render(); }
        var pack = !e.target.closest('[data-pk-icolour], .pk-pack__more') && e.target.closest('[data-pk-pack]');
        if (pack) { if (+pack.dataset.pkPack !== self.state.pack) { self.state.pack = +pack.dataset.pkPack; self.render(); } return; }
        if (e.target.closest('[data-pk-upsell]')) { self.state.pack = 2; self.render(); return; }
        var tog = e.target.closest('[data-pk-itoggle]');
        if (tog) { var ti = +tog.dataset.pkItoggle; self.state.open[ti] = !self.state.open[ti]; self.render(); return; }
        var ic = e.target.closest('[data-pk-icolour]');
        if (ic) {
          var ii = +ic.dataset.pkI, cname = ic.dataset.pkIcolour;
          self.state.items[ii].colour = cname;
          if (ii === 0) { self.state.colour = cname; self.renderColours(); }
          self.render();
          var co = self.fabric.colours.find(function (x) { return x.name === cname; });
          if (self.gallery && self.gallery.setColour) self.gallery.setColour(co, self.fabric, true);
          return;
        }
        var isz = e.target.closest('[data-pk-isize]');
        if (isz) { self.state.items[+isz.dataset.pkI].size = isz.dataset.pkIsize; self.render(); return; }
        var card = e.target.closest('[data-pk-sizecard]');
        if (card) { self.state.size = card.dataset.pkSizecard; self.render(); return; }
        if (e.target.closest('[data-pk-qty-plus]')) { self.state.qty = Math.min(20, self.state.qty + 1); self.render(); return; }
        if (e.target.closest('[data-pk-qty-minus]')) { self.state.qty = Math.max(1, self.state.qty - 1); self.render(); return; }
        if (self.q && self.ladClick(e)) return;
        var lay = e.target.closest('[data-pk-layouts] .pk-chip');
        if (lay) {
          self.state.seat.qty = +lay.dataset.seat;
          self.state.back.qty = +lay.dataset.back;
          self.state.chaise.qty = +lay.dataset.chaise;
          self._focus = { piece: 'seat', size: self.state.seat.size };
          self.render();
          return;
        }
        var row = e.target.closest('[data-pk-row]');
        if (!row) {
          if (e.target.closest('[data-pk-atc]')) { if (self._notify && self._notify.length && !self.lines().length) self.notify(self._notify); else self.add(); }
          return;
        }
        var p = row.dataset.pkRow;
        var sz = e.target.closest('[data-pk-size]');
        if (sz) {
          if (self._autoSize) delete self._autoSize[p];
          self._userSize[p] = true;
          self.state[p].size = sz.dataset.pkSize;
          if (!self.state[p].qty) self.state[p].qty = 1;
          self._focus = { piece: p, size: self.state[p].size };
          self.render();
          return;
        }
        if (e.target.closest('[data-pk-plus], [data-pk-minus]')) self._focus = { piece: p, size: self.state[p].size };
        if (e.target.closest('[data-pk-plus]')) { self.state[p].qty = Math.min(20, self.state[p].qty + 1); self.render(); }
        if (e.target.closest('[data-pk-minus]')) { self.state[p].qty = Math.max(0, self.state[p].qty - 1); self.render(); }
      });
    }
    add() {
      var self = this;
      var ls = this.lines();
      if (this.adding || !ls.length || ls.some(function (l) { return !l.variant || !l.variant.available; })) return;
      this.adding = true;
      this.render();
      (this.SS ? pkOfferSync(this._cart) : Promise.resolve()).then(function (c) {
        if (c) self._cart = c;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ls.map(function (l) { return { id: l.variant.id, quantity: l.qty }; }), sections: drawerSections() })
        });
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
        return r.json();
      }).then(function (added) {
        var bus = window.EventBus && typeof window.EventBus.emit === 'function' ? window.EventBus : null;
        var art = self.closest('.pk'); if (art && art._pkSel) art._pkAdded = art._pkSel.key;
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: added } }));
        if (bus && document.getElementById('ajaxCart')) {
          bus.emit('cart:changed', added);
          bus.emit('cart:show');
        } else {
          window.location.href = self.D.cartUrl;
        }
      }).catch(function (err) {
        console.error('[pdp-k] add to cart failed', err);
        var issue = self.querySelector('[data-pk-issue]');
        issue.hidden = false;
        issue.textContent = 'We couldn’t add that to your cart (' + err.message + '). Please try again.';
      }).finally(function () {
        self.adding = false;
        self.render();
      });
    }
  }
  if (!customElements.get('pk-picker')) customElements.define('pk-picker', PkPicker);


  /* The theme's cart drawer re-renders from these sections (same list as the theme's product form). */
  function drawerSections() {
    return ['ajaxCartContent', 'ajaxCartBtn', 'cartContent'].map(function (id) {
      var el = document.getElementById(id);
      var sec = el && el.closest('.shopify-section');
      return sec ? sec.id.replace('shopify-section-', '') : null;
    }).filter(function (s, i, a) { return s && a.indexOf(s) === i; });
  }

  /* ---------- Drawer (size guide) ---------- */
  var lastFocus = null;
  function openDrawer(d) {
    lastFocus = document.activeElement;
    d.hidden = false;
    d.offsetHeight;
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var close = d.querySelector('.pk-drawer__close');
    if (close) close.focus();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, reduceMotion.matches ? 0 : 400);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pk-drawer-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-pk-drawer-open')); if (d) openDrawer(d); return; }
    var c = e.target.closest('[data-pk-drawer-close]');
    if (c) closeDrawer(c.closest('.pk-drawer'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.pk-drawer.is-open');
    if (d) closeDrawer(d);
  });

  /* ---------- Ships-by date ---------- */
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function fillShipDates() {
    document.querySelectorAll('[data-pk-ships-by]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-pk-ships-by'), 10) || 2;
      el.textContent = addBusinessDays(new Date(), n).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initSticky() {
    document.querySelectorAll('[data-pk-sticky]').forEach(function (bar) {
      if (bar._ready) return;
      bar._ready = true;
      var sel = bar.getAttribute('data-pk-sticky');
      document.body.appendChild(bar);
      var cta = bar.querySelector('[data-pk-sticky-cta]');
      /* 23 Oct 2026 (owner: "For the sticky atc button just scroll back to buy box section"): the bar never adds
         to cart itself. It scrolls back to the buy box; when the selection is incomplete it says what is missing
         (pickers' missingInfo) and scrolls to that part instead. */
      cta.addEventListener('click', function () {
        var t = document.querySelector(sel);
        var host = t && t.closest('pk-picker, pk-fa-sets');
        if (host && host.adding) return;
        var miss = t && t.disabled && host && typeof host.missingInfo === 'function' ? host.missingInfo() : null;
        var meta = bar.querySelector('[data-pk-sticky-meta]');
        if (miss && meta) meta.textContent = miss.text;
        var pick = (miss && miss.el) || host || t;
        if (!pick) return;
        var focusIt = function () {
          var f = pick.querySelector('button:not([disabled]), select, [tabindex="0"]');
          if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
        };
        if (miss) setTimeout(focusIt, reduceMotion.matches ? 0 : 950);
        var top = Math.max(0, pick.getBoundingClientRect().top + window.scrollY - 90);
        /* Eased by hand: the page cancels native smooth scrolling. */
        var start = window.scrollY, dist = top - start, t0 = null, dur = Math.min(900, 300 + Math.abs(dist) / 6);
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur), e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          window.scrollTo(0, start + dist * e);
          if (p < 1) requestAnimationFrame(step);
        };
        if (reduceMotion.matches) window.scrollTo(0, top); else requestAnimationFrame(step);
      });
      /* Room under the footer so the bar never covers it. */
      var pad = function () { document.body.style.paddingBottom = bar.offsetHeight + 'px'; };
      pad();
      window.addEventListener('resize', pad);
      var update = function () {
        var t = document.querySelector(sel);
        /* 1 Nov 2026 (owner): show only once the main add-to-cart button has scrolled up past the top of the
           screen, on every screen size. While the shopper is still choosing above it, the bar stays hidden.
           Matches K11 (Jun 2026), where the bar appeared after the offer section and beat no bar. */
        var rect = t ? t.getBoundingClientRect() : null;
        var show = !!rect && rect.bottom < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        cta.tabIndex = show ? 0 : -1;
        /* QA 17 Oct (visual H2): lift the Richpanel chat launcher above the bar while it shows (pdp-k.css). */
        document.documentElement.classList.toggle('pk-sticky-on', show);
        document.documentElement.style.setProperty('--pk-sticky-h', bar.offsetHeight + 'px');
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- Limited stock bar ----------
     Same behaviour and session keys as the live kv-sofa-cover-bundle picker (owner decision A7):
     starts at a random 68–84% sold per browser session, rises 1% every 10 seconds, stops at 95%. */
  var STOCK_KEY = 'kv-scb-stock-urgency-fill';
  var STOCK_TIME_KEY = 'kv-scb-stock-urgency-time';
  var STOCK_MIN = 68, STOCK_MAX = 84, STOCK_CAP = 95, STOCK_TICK = 10000;
  function stockFill() {
    var now = Date.now();
    var fill = parseInt(sessionStorage.getItem(STOCK_KEY), 10);
    var time = parseInt(sessionStorage.getItem(STOCK_TIME_KEY), 10);
    if (isNaN(fill) || isNaN(time) || fill < STOCK_MIN || fill > STOCK_CAP) {
      fill = Math.floor(Math.random() * (STOCK_MAX - STOCK_MIN + 1)) + STOCK_MIN;
      sessionStorage.setItem(STOCK_KEY, String(fill));
      sessionStorage.setItem(STOCK_TIME_KEY, String(now));
      return fill;
    }
    var steps = Math.floor((now - time) / STOCK_TICK);
    if (steps > 0) {
      fill = Math.min(STOCK_CAP, fill + steps);
      sessionStorage.setItem(STOCK_KEY, String(fill));
      sessionStorage.setItem(STOCK_TIME_KEY, String(time + steps * STOCK_TICK));
    }
    return fill;
  }
  function renderStock() {
    var bars = document.querySelectorAll('[data-pk-stock]');
    if (!bars.length) return;
    var fill;
    try { fill = stockFill(); } catch (err) { console.error('[pdp-k] stock bar storage unavailable', err); fill = STOCK_MIN; }
    bars.forEach(function (bar) {
      var f = bar.querySelector('[data-pk-stock-fill]');
      var p = bar.querySelector('[data-pk-stock-pct]');
      var pb = bar.querySelector('[data-pk-stock-bar]');
      if (f) f.style.width = fill + '%';
      if (p) p.textContent = (100 - fill) + '% Left';
      if (pb) pb.setAttribute('aria-valuenow', String(100 - fill));
    });
  }
  var stockTimer = null;
  function initStock() {
    renderStock();
    if (!stockTimer && document.querySelector('[data-pk-stock]')) stockTimer = setInterval(renderStock, STOCK_TICK);
  }

  /* ---------- Size guide: tabs, range bars, table, inch/cm ---------- */
  function parseDims(str) {
    var m = String(str || '').match(/L\s*([\d.]+)\s*[–-]\s*([\d.]+)\D+W\s*([\d.]+)\s*[–-]\s*([\d.]+)/);
    return m ? { L: [+m[1], +m[2]], W: [+m[3], +m[4]] } : null;
  }
  function initSizeGuide(root) {
    if (root._pkSg) return;
    root._pkSg = true;
    var raw = root.querySelector('[data-pk-sg-data]');
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (err) { console.error('[pdp-k] size guide data unreadable', err); return; }
    /* 30 Oct 2026 (owner): original-style guide. Rows come from the product's size_guide metaobject, e.g.
       {t: "Seat Cover (Small)", l: "25.6 - 35.4", w: "25.6 - 35.4", h: "2 - 7.9"}. */
    var orig = false;
    if (data.rows) {
      var conv = {};
      var rng = function (v) { var m = String(v || '').match(/([\d.]+)\s*[–-]\s*([\d.]+)/); return m ? [+m[1], +m[2]] : null; };
      data.rows.forEach(function (r) {
        var t = /seat/i.test(r.t) ? 'seat' : /back/i.test(r.t) ? 'back' : /chaise/i.test(r.t) ? 'chaise' : '';
        var z = /small/i.test(r.t) ? 'S' : /medium/i.test(r.t) ? 'M' : /large/i.test(r.t) ? 'L' : '';
        if (!t || !z) return;
        (conv[t] = conv[t] || {})[z] = { L: rng(r.l), W: rng(r.w), H: rng(r.h) };
      });
      data = conv;
      orig = true;
    }
    var unit = 'in';
    function fmt(v) { return unit === 'cm' ? Math.round(v * 2.54) : v; }
    function sym() { return unit === 'cm' ? ' cm' : '″'; }
    function bar(label, sizes, dim) {
      var lo = Infinity, hi = -Infinity, same = true, first = sizes[0][1][dim];
      sizes.forEach(function (s) { var r = s[1][dim]; lo = Math.min(lo, r[0]); hi = Math.max(hi, r[1]); if (r[0] !== first[0] || r[1] !== first[1]) same = false; });
      var span = hi - lo || 1, segs = '', ticks = {};
      if (same) {
        segs = '<span class="pk-sg__seg pk-sg__seg--1" style="left:0;width:100%">' + sizes.map(function (s) { return s[0]; }).join(' · ') + '</span>';
        ticks[lo] = 1; ticks[hi] = 1;
      } else {
        sizes.forEach(function (s, i) {
          var r = s[1][dim];
          segs += '<span class="pk-sg__seg pk-sg__seg--' + (i + 1) + '" style="left:' + ((r[0] - lo) / span * 100) + '%;width:' + ((r[1] - r[0]) / span * 100) + '%">' + s[0] + '</span>';
          ticks[r[0]] = 1; ticks[r[1]] = 1;
        });
      }
      var tickHtml = Object.keys(ticks).map(Number).sort(function (a, b) { return a - b; }).map(function (t) {
        var p = (t - lo) / span * 100;
        return '<span class="pk-sg__tick' + (p === 0 ? ' is-first' : (p === 100 ? ' is-last' : '')) + '" style="left:' + p + '%">' + fmt(t) + '</span>';
      }).join('');
      return '<div class="pk-sg__range"><span class="pk-sg__range-label">' + label + (same ? ' <span>(same for every size)</span>' : '') + '</span>' +
        '<div class="pk-sg__track">' + segs + '</div><div class="pk-sg__ticks">' + tickHtml + '</div></div>';
    }
    function render() {
      root.querySelectorAll('[data-pk-sg-panel]').forEach(function (panel) {
        var type = panel.getAttribute('data-pk-sg-panel');
        var sizes = Object.keys(data[type] || {}).map(function (k) { return [k, orig ? data[type][k] : parseDims(data[type][k])]; }).filter(function (s) { return s[1]; });
        if (!sizes.length) return;
        if (orig) {
          var names = { S: 'Small', M: 'Medium', L: 'Large' };
          panel.querySelector('[data-pk-sg-table]').innerHTML =
            '<thead><tr><td></td>' + sizes.map(function (s) { return '<th scope="col">' + names[s[0]] + '</th>'; }).join('') + '</tr></thead><tbody>' +
            [['Length', 'L'], ['Width', 'W'], ['Height', 'H']].map(function (d) {
              if (!sizes.every(function (s) { return s[1][d[1]]; })) return '';
              return '<tr><th scope="row">' + d[0] + '</th>' + sizes.map(function (s) {
                return '<td>' + fmt(s[1][d[1]][0]) + '–' + fmt(s[1][d[1]][1]) + sym() + '</td>';
              }).join('') + '</tr>';
            }).join('') + '</tbody>';
          return;
        }
        panel.querySelector('[data-pk-sg-ranges]').innerHTML = bar('Length', sizes, 'L') + bar('Width', sizes, 'W');
        panel.querySelector('[data-pk-sg-table]').innerHTML =
          '<thead><tr><th scope="col">Size</th><th scope="col">Length</th><th scope="col">Width</th></tr></thead><tbody>' +
          sizes.map(function (s) {
            return '<tr><th scope="row">' + s[0] + '</th><td>' + fmt(s[1].L[0]) + '–' + fmt(s[1].L[1]) + sym() + '</td><td>' + fmt(s[1].W[0]) + '–' + fmt(s[1].W[1]) + sym() + '</td></tr>';
          }).join('') + '</tbody>';
      });
    }
    function select(type, focus) {
      root.querySelectorAll('[data-pk-sg-tab]').forEach(function (t) {
        var on = t.getAttribute('data-pk-sg-tab') === type;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      root.querySelectorAll('[data-pk-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-pk-sg-panel') !== type; });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pk-sg-tab]');
      if (t) { select(t.getAttribute('data-pk-sg-tab')); return; }
      var u = e.target.closest('[data-pk-sg-unit]');
      if (u) {
        unit = u.getAttribute('data-pk-sg-unit');
        root.querySelectorAll('[data-pk-sg-unit]').forEach(function (b) { var on = b === u; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        render();
      }
    });
    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-pk-sg-tab]') || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pk-sg-tab]'));
      var i = tabs.indexOf(e.target.closest('[data-pk-sg-tab]'));
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      select(next.getAttribute('data-pk-sg-tab'), true);
      e.preventDefault();
    });
    render();
  }

  /* ---------- Videos in split sections and the fade-up on scroll ---------- */
  function playQuietly(v) {
    v.muted = true;
    v.playsInline = true;
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      console.warn('[pdp-k] video did not autoplay', err && err.name);
      /* Autoplay can be blocked (Low Power Mode, data saver). Try again on the first touch or scroll. */
      var retry = function () { window.removeEventListener('touchstart', retry); window.removeEventListener('scroll', retry); if (v.paused && v.offsetParent !== null) v.play().catch(function (e2) { console.warn('[pdp-k] video still blocked', e2 && e2.name); }); };
      window.addEventListener('touchstart', retry, { passive: true, once: true });
      window.addEventListener('scroll', retry, { passive: true, once: true });
    });
  }
  var seen = null;
  function countUp(root) {
    root.querySelectorAll('[data-pk-count]').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-pk-count')) || 0;
      var start = null, dur = 1600;
      el.textContent = '0%';
      function step(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(to * eased) + '%';
        if (t < 1) requestAnimationFrame(step); else el.textContent = to + '%';
      }
      requestAnimationFrame(step);
      setTimeout(function () { el.textContent = to + '%'; }, dur + 200);
    });
  }
  function initReveal() {
    var els = document.querySelectorAll('.pk-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion.matches) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    document.documentElement.classList.add('pk-js-reveal');
    seen = seen || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* A section can hold two copies of its media box (one for phones, one for wider screens); play the one on screen. */
        var vids = Array.prototype.slice.call(e.target.querySelectorAll('[data-pk-media-box] [data-pk-media-item].is-active video'));
        if (e.isIntersecting) {
          if (!e.target.classList.contains('is-in')) countUp(e.target);
          e.target.classList.add('is-in');
          vids.forEach(function (v) { if (v.offsetParent !== null && !reduceMotion.matches) playQuietly(v); else v.pause(); });
        } else {
          vids.forEach(function (v) { v.pause(); });
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { seen.observe(el); });
  }

  /* Product title on one line: shrink the font until it fits the column (min 18px, then it may wrap). */
  function fitTitles() {
    /* Round 121 (owner, 19 Oct 2026): the title is one line at one size on every product page (CSS). Only a title too
       long for that line is shrunk, for its own page, through --pk-fit (heading-fit-2026.js leaves custom properties
       alone, so the two scripts no longer fight). */
    document.querySelectorAll('.pk__title-live').forEach(function (t) {
      t.style.removeProperty('--pk-fit');
      t.style.removeProperty('white-space');
      var w = t.clientWidth;
      if (!w) return;
      var s = parseFloat(getComputedStyle(t).fontSize);
      while (t.scrollWidth > w + 1 && s > 16) { s -= 0.5; t.style.setProperty('--pk-fit', s + 'px'); }
    });
  }
  window.addEventListener('resize', fitTitles);
  window.pkFitTitles = fitTitles;
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);
  /* QA 2026-10-19: fonts.ready can resolve before the heading font is in use; the wider late font then pushed a long
     sale title ("... - Checkered | Last Chance") past the column and the page scrolled sideways. Fit again when fonts finish and on load. */
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitTitles);
  window.addEventListener('load', fitTitles);

  function init() { fillShipDates(); initSticky(); initStock(); document.querySelectorAll('[data-pk-sg]').forEach(initSizeGuide); initReveal(); fitTitles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Round 99 (owner, 17 Oct 2026: light grey behind white-background photos, like Ruggable). Each gallery photo is
   checked once from a 24px copy: if its edges are white, it gets .pk-wb and the CSS lays it on light grey with
   mix-blend-mode: multiply, so the white turns grey and the product keeps its colours. Lifestyle photos are left
   alone. Photos that change later (colour, fabric or set switches) are checked again. */
(function () {
  'use strict';
  var cache = {};
  function small(src) {
    /* The whole photo at 24px: drop crop and height so it is not a cropped strip. */
    var u = new URL(src, location.href);
    u.searchParams.delete('crop');
    u.searchParams.delete('height');
    u.searchParams.set('width', '24');
    return u.toString();
  }
  function isWhite(url, done) {
    if (cache[url] !== undefined) {
      if (cache[url] instanceof Array) cache[url].push(done); else done(cache[url]);
      return;
    }
    cache[url] = [done];
    var t = new Image();
    t.crossOrigin = 'anonymous';
    t.onload = function () {
      var res = false;
      try {
        var c = document.createElement('canvas'), n = 24;
        c.width = n; c.height = n;
        var x = c.getContext('2d');
        x.drawImage(t, 0, 0, n, n);
        var d = x.getImageData(0, 0, n, n).data, pts = [[0, 0], [n - 1, 0], [0, n - 1], [n - 1, n - 1], [n >> 1, 0], [0, n >> 1], [n - 1, n >> 1]], ok = 0;
        pts.forEach(function (p) { var i = (p[1] * n + p[0]) * 4; if (d[i] >= 240 && d[i + 1] >= 240 && d[i + 2] >= 240) ok++; });
        res = ok >= pts.length - 1;
      } catch (e) { res = false; }
      var q = cache[url]; cache[url] = res;
      q.forEach(function (f) { f(res); });
    };
    t.onerror = function () { var q = cache[url]; cache[url] = false; q.forEach(function (f) { f(false); }); };
    t.src = small(url);
  }
  function check(img) {
    var src = img.getAttribute('src');
    if (!src || img._pkWb === src) return;
    img._pkWb = src;
    isWhite(src, function (w) { if (img.getAttribute('src') === src) img.classList.toggle('pk-wb', w); });
  }
  function scan(root) { (root || document).querySelectorAll('pk-gallery .pk-s img, pk-gallery .pk-gal__thumb img').forEach(check); }
  function start() {
    scan();
    document.querySelectorAll('pk-gallery').forEach(function (g) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          if (m.type === 'attributes' && m.target.tagName === 'IMG') check(m.target);
          else if (m.addedNodes.length) scan(g);
        });
      }).observe(g, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { scan(); });
})();
